import React, { useState, useEffect,useMemo} from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
    InputAdornment,
  TablePagination,
  Chip,

  Button,
  Paper,
  Grid,
  IconButton,
  Divider,
  Card,
  CardContent,
  CardHeader,
 
  Alert,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Stack,
} from '@mui/material';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Download as DownloadIcon,
  Business as BusinessIcon,
  Description as DescriptionIcon,
  Schedule as ScheduleIcon,
  CalendarToday as CalendarIcon,
  Category as CategoryIcon,

} from '@mui/icons-material';
import { Search, Clear } from '@mui/icons-material';

import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';



import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { notoSansBase64 } from './notosans'
import { verdanaFont } from './verdant'
import { verdanaboldFont } from './verdanbold'
import { notoSansboldBase64 } from './notobold'

const DynamicQuotationForm = () => {
  const [loading, setLoading] = useState(false);
  const [quotations, setQuotations] = useState([]);
  const [selectedQuotation, setSelectedQuotation] = useState(null);
  const [openFeatureCategoryDialog, setOpenFeatureCategoryDialog] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState('');
const [previewMode, setPreviewMode] = useState(false);
  const [quotationData, setQuotationData] = useState({
    title: '',
    clientName: '',
    clientAddress: '',
     discount: 0,
    parts: [
      {
        id: 1,
        title: '',
        description: '',
        items: [
          { id: 1, description: '', amount: 0 },
          { id: 2, description: '', amount: 0 }
        ]
      }
    ],
    featureCategories: [
      {
        id: 1,
        name: '',
        color: '',
        features: []
      },
      {
        id: 2,
        name: '',
        color: '',
        features: []
      }
    ],
    note: '',
    validity: '',
    timeline: '',
    paymentTermsText: '',

    annualRenewal: 0
  });

  // Load saved quotations on component mount
  useEffect(() => {
    loadQuotations();
  }, []);
  const [selectedId, setSelectedId] = useState(null);
  const [autoGeneratePDF, setAutoGeneratePDF] = useState(false);

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [quotationTableData, setQuotationTableData] = useState([]);

  // // 2. Update your loadQuotations function to store table data:
  const loadQuotations = async () => {
    try {
      const response = await fetch('/api/quotations');
      if (response.ok) {
        const data = await response.json();
        setQuotations(data);
        // Format data for table display
        const tableData = data.map(quote => ({
          id: quote.id,
          title: quote.title || 'Untitled',
          clientName: quote.clientName || 'No Client',
          createdAt: new Date(quote.createdAt).toLocaleDateString() || 'N/A',
          total: calculateQuotationTotal(quote)
        }));
        setQuotationTableData(tableData);
      }
    } catch (error) {
      console.error('Error loading quotations:', error);
    }
  };
// Add these state variables to your component
const [searchTerm, setSearchTerm] = useState('');
const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(5);

// Add these useMemo hooks for filtering and pagination
const filteredData = useMemo(() => {
  if (!searchTerm) return quotationTableData;
  
  const lowercaseSearch = searchTerm.toLowerCase();
  return quotationTableData.filter(quote => 
    quote.title.toLowerCase().includes(lowercaseSearch) ||
    quote.clientName.toLowerCase().includes(lowercaseSearch) ||
    quote.total.toString().includes(searchTerm) ||
    quote.createdAt.includes(searchTerm)
  );
}, [quotationTableData, searchTerm]);

const paginatedData = useMemo(() => {
  const startIndex = page * rowsPerPage;
  return filteredData.slice(startIndex, startIndex + rowsPerPage);
}, [filteredData, page, rowsPerPage]);

// Add these handler functions
const handleSearch = (event) => {
  setSearchTerm(event.target.value);
  setPage(0); // Reset to first page when searching
};

const clearSearch = () => {
  setSearchTerm('');
  setPage(0);
};

const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
};
  useEffect(() => {
    if (
      quotationData &&
      quotationData.id === selectedId &&
      autoGeneratePDF
    ) {
      handleGeneratePDF();
      setAutoGeneratePDF(false); // Reset trigger
    }
  }, [quotationData]);

  // 3. Add this helper function to calculate quotation total:
  const calculateQuotationTotal = (quotation) => {
    if (!quotation.parts) return 0;
    return quotation.parts.reduce((sum, part) => {
      return sum + (part.items || []).reduce((itemSum, item) => itemSum + (item.amount || 0), 0);
    }, 0);
  };

  // 4. Add these handler functions:
  const handleEditQuotation = async (id) => {
    await loadQuotation(id);
    setOpenFormDialog(true);
  };

  const handleNewQuotation = () => {
    createNewQuotation();
    setOpenFormDialog(true);
  };

  const handleCloseForm = () => {
    setOpenFormDialog(false);
    setSelectedQuotation(null);
  };

  const loadQuotation = async (id) => {
    try {
      const response = await fetch(`/api/quotations/${id}`);
      if (response.ok) {
        const data = await response.json();

        // Convert features array to featuresText for display
        const convertedData = {
          ...data,
          featureCategories: data.featureCategories.map(category => ({
            ...category,
            featuresText: category.features ? category.features.join('\n') : '',
            features: category.features || []
          }))
        };

        setQuotationData(convertedData);
        setSelectedQuotation(id);
      }
    } catch (error) {
      console.error('Error loading quotation:', error);
    }
  };

  // Part management functions
  const addPart = () => {
    const newPart = {
      id: Date.now(),
      title: `Part ${String.fromCharCode(65 + quotationData.parts.length)}`,
      description: `– New Part ${quotationData.parts.length + 1}`,
      items: []
    };
    setQuotationData(prev => ({
      ...prev,
      parts: [...prev.parts, newPart]
    }));
  };

  const deletePart = (partId) => {
    setQuotationData(prev => ({
      ...prev,
      parts: prev.parts.filter(part => part.id !== partId)
    }));
  };

  const updatePart = (partId, field, value) => {
    setQuotationData(prev => ({
      ...prev,
      parts: prev.parts.map(part =>
        part.id === partId ? { ...part, [field]: value } : part
      )
    }));
  };

  // Item management functions
  const addItem = (partId) => {
    const newItem = {
      id: Date.now(),
      description: '',
      amount: 0
    };
    setQuotationData(prev => ({
      ...prev,
      parts: prev.parts.map(part =>
        part.id === partId
          ? { ...part, items: [...part.items, newItem] }
          : part
      )
    }));
  };

  const deleteItem = (partId, itemId) => {
    setQuotationData(prev => ({
      ...prev,
      parts: prev.parts.map(part =>
        part.id === partId
          ? { ...part, items: part.items.filter(item => item.id !== itemId) }
          : part
      )
    }));
  };
  // Replace the existing handleGeneratePDF function with this:

























  ; // Replace with actual path or base64  this is UI






  // const handleGeneratePDF = async () => {
  //   if (!quotationData.clientName) {
  //     alert('Please add client name before generating PDF');
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const doc = new jsPDF();
  //     const pageHeight = 297;
  //     const usableHeight = pageHeight - 50; // Adjusted for header and footer space

  //     // ✅ Load custom fonts
  //     doc.addFileToVFS("NotoSans.ttf", notoSansBase64);
  //     doc.addFont("NotoSans.ttf", "NotoSans", "normal");
  //     doc.addFont("NotoSans.ttf", "NotoSans", "bold");

  //     doc.addFileToVFS("Verdana.ttf", verdanaFont);
  //     doc.addFont("Verdana.ttf", "Verdana", "normal");

  //     doc.addFileToVFS("VerdanaBold.ttf", verdanaboldFont);
  //     doc.addFont("VerdanaBold.ttf", "VerdanaBold", "normal");

  //     // ✅ Function to add footer to any page
  //     const addFooter = () => {
  //       doc.setFontSize(8);
  //       doc.setTextColor(0, 0, 0);
  //       doc.setFont("Verdana", "normal");

  //       // Left side - Address and Phone
  //       doc.text('B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,', 15, 283);
  //       doc.text('Mahadevapura Post Bangalore – 560048', 15, 288);
  //       doc.text('Phone: +91 (636) 465 7660, +91 (990) 050 2404,', 15, 293);

  //       // Right side - Email and Website
  //       doc.text('Email: info@excerptech.com', 150, 287);
  //       doc.text('Website: www.excerptech.com', 150, 292);
  //     };

  //     // ✅ Function to add header and logo to any page
  //     const addHeaderAndLogo = () => {
  //       // Header image
  //       const headerImg = '/img/newHeader.jpg';
  //       doc.addImage(headerImg, 'JPEG', 0, 0, 210, 10);

  //       // Logo positioning
  //       const logoWidth = 42.5;
  //       const logoHeight = 18;
  //       const logoY = 18;

  //       // Left and right logos
  //       doc.addImage('img/log1.png', 'PNG', 5, logoY, logoWidth, logoHeight);
  //       doc.addImage('img/logo2.png', 'PNG', 210 - 8 - logoWidth, logoY, logoWidth, logoHeight);

  //       // ✅ FIXED: Title with proper text wrapping and positioning
  //       const titleY = logoY + logoHeight / 2;
  //       doc.setFont('VerdanaBold', 'normal');
  //       doc.setFontSize(18);
  //       doc.setTextColor(0, 0, 0);

  //       const title = quotationData.title || 'Website design and CRM Quote';
  //       const maxTitleWidth = 120; // Available width for title (considering logos on both sides)

  //       // Split title into lines if too long
  //       const titleLines = doc.splitTextToSize(title, maxTitleWidth);

  //       // Calculate starting Y position for multi-line titles
  //       let titleStartY = titleY;
  //       if (titleLines.length > 1) {
  //         titleStartY = titleY - ((titleLines.length - 1) * 3); // Adjust for multiple lines
  //       }

  //       // Draw each line of the title
  //       titleLines.forEach((line, index) => {
  //         doc.text(line, 105, titleStartY + (index * 7), { align: 'center' }); // ✅ FIXED: Increased line spacing from 6 to 7
  //       });

  //       // ✅ Add footer to every page when header is added
  //       addFooter();
  //     };

  //     // ✅ Add header and footer to first page
  //     addHeaderAndLogo();

  //     let yPos = 18 + 18 + 12; // logoY + logoHeight + spacing

  //     // ✅ Adjust yPos if title is multi-line
  //     const title = quotationData.title || 'Website design and CRM Quote';
  //     const maxTitleWidth = 120;
  //     const titleLines = doc.splitTextToSize(title, maxTitleWidth);
  //     if (titleLines.length > 1) {
  //       yPos += (titleLines.length - 1) * 7; // ✅ FIXED: Increased spacing from 3 to 7 to match title line spacing
  //     }

  //     // ✅ Client Name (Verdana Bold)
  //     doc.setFontSize(10);
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setTextColor(0, 0, 0);
  //     doc.text(quotationData.clientName, 15, yPos);
  //     yPos += 6;

  //     // ✅ Client Address (Verdana Normal)
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setTextColor(0, 0, 0);
  //     const addressMaxWidth = 90;
  //     const lineHeight = 6;

  //     (quotationData.clientAddress || '').split('\n').forEach(line => {
  //       const wrappedLines = doc.splitTextToSize(line.trim(), addressMaxWidth);
  //       wrappedLines.forEach(wrappedLine => {
  //         doc.text(wrappedLine, 15, yPos);
  //         yPos += lineHeight;
  //       });
  //     });

  //     yPos += 0;

  //     // ✅ Services heading (Verdana Bold)
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setFontSize(15);
  //     doc.setTextColor(0, 0, 0);
  //     doc.text('Services', 105, yPos, { align: 'center' });

  //     // Underline
  //     const textWidth = doc.getTextWidth('Services');
  //     const xStart = 105 - textWidth / 2;
  //     const yLine = yPos + 1.5;
  //     doc.line(xStart, yLine, xStart + textWidth, yLine);

  //     yPos += 8;

  //     // ✅ FIXED: Function to check page space and add header/footer if new page
  //     const checkPageSpace = (requiredSpace) => {
  //       if (yPos + requiredSpace > usableHeight) {
  //         doc.addPage();
  //         addHeaderAndLogo();
  //         // ✅ FIXED: Proper yPos calculation for new page considering multi-line titles
  //         const titleLines = doc.splitTextToSize(quotationData.title || 'Website design and CRM Quote', 120);
  //         yPos = 58 + (titleLines.length > 1 ? (titleLines.length - 1) * 7 : 0); // ✅ FIXED: Consistent spacing calculation
  //         return true;
  //       }
  //       return false;
  //     };

  //     // ✅ Function to set font based on content (Rupee symbol check)
  //     const setSmartFont = (text, style = 'normal') => {
  //       if (typeof text === 'string' && text.includes('₹')) {
  //         doc.setFont('NotoSans', style);
  //       } else {
  //         if (style === 'bold') {
  //           doc.setFont('VerdanaBold', 'normal');
  //         } else {
  //           doc.setFont('Verdana', 'normal');
  //         }
  //       }
  //     };

  //     let tableData = [];

  //     // Add the header row
  //     tableData.push([
  //       {
  //         content: 'Estimated Cost',
  //         colSpan: 3,
  //         styles: {
  //           halign: 'center',
  //           fillColor: [51, 85, 163],
  //           textColor: [255, 255, 255],
  //           fontStyle: 'normal',
  //           fontSize: 11,
  //           font: 'VerdanaBold',
  //         }
  //       }
  //     ]);

  //     let serialNumber = 1;
  //     let grandTotal = 0;
  //     const partTotals = {};

  //     // Loop through all parts dynamically
  //     quotationData.parts.forEach((part, partIndex) => {
  //       const partLetter = String.fromCharCode(65 + partIndex);
  //       let partTotal = 0;

  //       // Add part header
  //       tableData.push([
  //         { 
  //           content: `Part ${partLetter} – ${part.title}`, 
  //           colSpan: 3, 
  //           styles: { 
  //             halign: 'left', 
  //             fontStyle: 'normal', 
  //             fontSize: 10,
  //             font: 'VerdanaBold',
  //           } 
  //         }
  //       ]);

  //       // Add items for this part
  //       part.items.forEach(item => {
  //         tableData.push([
  //           {
  //             content: `${serialNumber++}`,
  //             styles: { font: 'Verdana' }
  //           },
  //           {
  //             content: item.description,
  //             styles: { font: 'Verdana' }
  //           },
  //           {
  //             content: `₹ ${item.amount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
  //             styles: { 
  //               halign: 'right', 
  //               fontSize: 9.5,
  //               font: 'NotoSans',
  //               cellPadding: { top: 2, right: 2, bottom: 2, left: 2 } 
  //             }
  //           }
  //         ]);
  //         partTotal += item.amount;
  //       });

  //       // Add part total row
  //       tableData.push([
  //         {
  //           content: '',
  //           styles: { font: 'Verdana' }
  //         },
  //         {
  //           content: `${partLetter} – Total`,
  //           styles: {
  //             halign: 'right',
  //             fontStyle: 'normal',
  //             font: 'Verdana',
  //             fillColor: [240, 248, 255]
  //           }
  //         },
  //         {
  //           content: `₹ ${partTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
  //           styles: {
  //             halign: 'right',
  //             fontStyle: 'normal',
  //             font: 'NotoSans',
  //             fillColor: [240, 248, 255],
  //           }
  //         }
  //       ]);

  //       partTotals[partLetter] = partTotal;
  //       grandTotal += partTotal;
  //     });

  //     // Generate the total label dynamically
  //     const partLetters = Object.keys(partTotals);
  //     const totalLabel = `Total (${partLetters.join('+')})`;

  //     // Add grand total row
  //     tableData.push([
  //       {
  //         content: '',
  //         styles: { font: 'Verdana' }
  //       },
  //       {
  //         content: totalLabel,
  //         styles: {
  //           halign: 'right',
  //           fontStyle: 'normal',
  //           font: 'VerdanaBold',
  //         }
  //       },
  //       {
  //         content: `₹ ${grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
  //         styles: {
  //           halign: 'right',
  //           fontStyle: 'normal',
  //           font: 'NotoSans',
  //         }
  //       }
  //     ]);

  //     autoTable(doc, {
  //       startY: yPos,
  //       body: tableData,
  //       theme: 'grid',
  //       styles: {
  //         fontSize: 9.5,
  //         textColor: [0, 0, 0],
  //         cellPadding: 3,
  //         lineColor: [0, 0, 0],
  //         lineWidth: 0.5, // ✅ FIXED: Reduced border thickness from 1.2 to 0.5
  //         fontStyle: 'normal',
  //         font: 'Verdana',
  //       },
  //       headStyles: {
  //         font: 'VerdanaBold',
  //         fontStyle: 'normal',
  //         lineColor: [0, 0, 0],
  //         lineWidth: 0.5, // ✅ FIXED: Reduced border thickness from 1.2 to 0.5
  //       },
  //       bodyStyles: {
  //         font: 'Verdana',
  //         lineColor: [0, 0, 0],
  //         lineWidth: 0.5, // ✅ FIXED: Reduced border thickness from 1.2 to 0.5
  //       },
  //       columnStyles: {
  //         0: { cellWidth: 20, halign: 'center' },
  //         1: { cellWidth: 130, halign: 'left' },
  //         2: { cellWidth: 35, halign: 'right' }
  //       },
  //       margin: { left: 15, right: 15 },
  //       didParseCell: data => {
  //         const cell = data.cell.text?.[0];
  //         if (/^[A-Z] – Total$/.test(cell)) {
  //           data.cell.styles.fillColor = [240, 248, 255];
  //           data.cell.styles.fontStyle = 'normal';
  //           data.cell.styles.font = 'VerdanaBold';
  //         }
  //         if ((cell?.startsWith('Total (') || cell === 'Total') && data.column.index > 0) {
  //           data.cell.styles.fontStyle = 'normal';
  //           data.cell.styles.font = 'VerdanaBold';
  //         }
  //         if (cell?.includes('₹')) {
  //           data.cell.styles.font = 'NotoSans';
  //         }
  //       },
  //       didDrawPage: function(data) {
  //         // ✅ FIXED: Add header and footer to each new page created by autoTable
  //         if (data.pageNumber > 1) {
  //           addHeaderAndLogo();
  //         }
  //       },
  //       didDrawCell: function (data) {
  //         if (data.row.index === 0 && data.column.index === 0) {
  //           const pageWidth = doc.internal.pageSize.getWidth();
  //           doc.addImage(
  //             'img/newHeader.jpg',
  //             'JPEG',
  //             data.cell.x,
  //             data.cell.y,
  //             pageWidth - 25,
  //             10.5
  //           );

  //           doc.setFontSize(15);
  //           doc.setTextColor(255, 255, 255);
  //           doc.setFont("VerdanaBold", "normal");

  //           const text = 'Estimated Cost';
  //           const textX = data.cell.x + 90;
  //           const textY = data.cell.y + 7;
  //           doc.text(text, textX, textY, "center");
  //         }
  //       }
  //     });

  //     // ✅ FIXED: Get the final Y position and ensure proper spacing
  //     yPos = doc.lastAutoTable.finalY + 10;

  //     // ✅ Note section (Verdana except for rupee)
  //     checkPageSpace(15);
  //     doc.setFillColor(255, 255, 0);


  // const noteText = `Note: ${quotationData.note}`;
  // const noteWidth = doc.getTextWidth(noteText);

  // // Reduced padding (was +6, now +2 or +3)
  // doc.rect(15, yPos - 3, noteWidth +30 , 8, 'F')
  //     doc.setFontSize(10);
  //     setSmartFont(noteText, 'bold');
  //     doc.setTextColor(0, 0, 0);
  //     doc.text(noteText, 18, yPos + 2);
  //     yPos += 12;

  //     // ✅ Validity (Verdana)
  //     checkPageSpace(10);
  //     doc.setFontSize(10);
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setTextColor(0, 0, 0);
  //     doc.text('Validity:', 18, yPos);
  //     doc.setFont('Verdana', 'normal');
  //     doc.text(quotationData.validity || 'This quotation is valid for 30 days from the date of issue.', 37, yPos);
  //     yPos += 6;

  //     // ✅ Timeline (Verdana)
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.text('Timeline:', 18, yPos);
  //     doc.setFont('Verdana', 'normal');
  //     doc.text('Estimated project duration: 2-3 weeks from the start date.', 37, yPos);
  //     yPos += 10;

  //     // ✅ Payment Terms (Verdana)
  //     checkPageSpace(30);
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setFontSize(12);
  //     doc.text('PAYMENT TERMS', 18, yPos);

  //     doc.setLineWidth(0.5);
  //     doc.line(18, yPos + 1, 55, yPos + 1);
  //     yPos += 8;

  //     doc.setFont('Verdana', 'normal');
  //     doc.setFontSize(10);
  //     const paymentPoints = [
  //       '50% Advance Payment: To initiate the project.',
  //       '30% Payment: Upon completion of the Configuration.',
  //       '20% Payment: After final sign-off.'
  //     ];

  //     paymentPoints.forEach((point) => {
  //       checkPageSpace(12);
  //       const bullet = `• ${point}`;
  //       const lines = doc.splitTextToSize(bullet, 170);
  //       doc.text(lines, 22, yPos);
  //       yPos += lines.length * 6;
  //     });

  //     // ✅ Features section (Verdana)
  //     if (quotationData.featureCategories?.length) {
  //       quotationData.featureCategories.forEach((cat, index) => {
  //         const features = cat.featuresText?.split('\n').filter(f => f.trim()) || cat.features || [];
  //         if (!features.length) return;

  //         yPos += 6;
  //         checkPageSpace(features.length * 6 + 20);

  //         const x = 18;
  //         const sectionTitle = (cat.name || `FEATURE ${index + 1}`).toUpperCase();

  //         doc.setFont('VerdanaBold', 'normal');
  //         doc.setFontSize(12);
  //         doc.text(sectionTitle, x, yPos);

  //         const textWidth = doc.getTextWidth(sectionTitle);
  //         doc.setLineWidth(0.5);
  //         doc.line(x, yPos + 1, x + textWidth, yPos + 1);
  //         yPos += 8;

  //         doc.setFont('Verdana', 'normal');
  //         doc.setFontSize(10);

  //         features.forEach((feature) => {
  //           checkPageSpace(12);
  //           const bulletText = `• ${feature}`;
  //           const lines = doc.splitTextToSize(bulletText, 160);
  //           doc.text(lines, 20, yPos);
  //           yPos += lines.length * 6;
  //         });

  //         yPos += 3;
  //       });
  //     }

  //     // ✅ Ensure footer is added to the final page if content was added after table
  //     const currentPage = doc.getCurrentPageInfo().pageNumber;
  //     const totalPages = doc.getNumberOfPages();

  //     if (currentPage === totalPages) {
  //       addFooter();
  //     }

  //     doc.save(`quotation-${quotationData.clientName.replace(/[^a-zA-Z0-9]/g, '_')}.pdf`);
  //   } catch (err) {
  //     console.error('PDF generation error:', err);
  //     alert('Something went wrong while generating PDF.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  // const handleGeneratePDF = async () => {
  //   if (!quotationData.clientName) {
  //     alert('Please add client name before generating PDF');
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const doc = new jsPDF();
  //     const pageHeight = 297;
  //     const usableHeight = pageHeight - 60; // More conservative footer space
  //     const footerStartY = 275; // Footer starts at this Y position

  //     // ✅ Load custom fonts
  //     doc.addFileToVFS("NotoSans.ttf", notoSansBase64);
  //     doc.addFont("NotoSans.ttf", "NotoSans", "normal");
  //     doc.addFont("NotoSans.ttf", "NotoSans", "bold");

  //     doc.addFileToVFS("Verdana.ttf", verdanaFont);
  //     doc.addFont("Verdana.ttf", "Verdana", "normal");

  //     doc.addFileToVFS("VerdanaBold.ttf", verdanaboldFont);
  //     doc.addFont("VerdanaBold.ttf", "VerdanaBold", "normal");

  //     // ✅ Function to add footer to any page
  //     const addFooter = () => {
  //       doc.setFontSize(8);
  //       doc.setTextColor(0, 0, 0);
  //       doc.setFont("Verdana", "normal");

  //       // Left side - Address and Phone
  //       doc.text('B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,', 15, 283);
  //       doc.text('Mahadevapura Post Bangalore – 560048', 15, 288);
  //       doc.text('Phone: +91 (636) 465 7660, +91 (990) 050 2404,', 15, 293);

  //       // Right side - Email and Website
  //       doc.text('Email: info@excerptech.com', 150, 287);
  //       doc.text('Website: www.excerptech.com', 150, 292);
  //     };

  //     // ✅ Function to add header and logo to any page
  //     const addHeaderAndLogo = () => {
  //       // Header image
  //       const headerImg = '/img/newHeader.jpg';
  //       doc.addImage(headerImg, 'JPEG', 0, 0, 210, 10);

  //       // Logo positioning
  //       const logoWidth = 42.5;
  //       const logoHeight = 18;
  //       const logoY = 18;

  //       // Left and right logos
  //       doc.addImage('img/log1.png', 'PNG', 5, logoY, logoWidth, logoHeight);
  //       doc.addImage('img/logo2.png', 'PNG', 210 - 8 - logoWidth, logoY, logoWidth, logoHeight);

  //       // ✅ FIXED: Title with proper text wrapping and positioning
  //       const titleY = logoY + logoHeight / 2;
  //       doc.setFont('VerdanaBold', 'normal');
  //       doc.setFontSize(18);
  //       doc.setTextColor(0, 0, 0);

  //       const title = quotationData.title || 'Website design and CRM Quote';
  //       const maxTitleWidth = 120; // Available width for title (considering logos on both sides)

  //       // Split title into lines if too long
  //       const titleLines = doc.splitTextToSize(title, maxTitleWidth);

  //       // Calculate starting Y position for multi-line titles
  //       let titleStartY = titleY;
  //       if (titleLines.length > 1) {
  //         titleStartY = titleY - ((titleLines.length - 1) * 3); // Adjust for multiple lines
  //       }

  //       // Draw each line of the title
  //       titleLines.forEach((line, index) => {
  //         doc.text(line, 105, titleStartY + (index * 7), { align: 'center' }); // ✅ FIXED: Increased line spacing from 6 to 7
  //       });

  //       // ✅ Add footer to every page when header is added
  //       addFooter();
  //     };

  //     // ✅ Add header and footer to first page
  //     addHeaderAndLogo();

  //     let yPos = 18 + 18 + 12; // logoY + logoHeight + spacing

  //     // ✅ Adjust yPos if title is multi-line
  //     const title = quotationData.title || 'Website design and CRM Quote';
  //     const maxTitleWidth = 120;
  //     const titleLines = doc.splitTextToSize(title, maxTitleWidth);
  //     if (titleLines.length > 1) {
  //       yPos += (titleLines.length - 1) * 7; // ✅ FIXED: Increased spacing from 3 to 7 to match title line spacing
  //     }

  //     // ✅ Client Name (Verdana Bold)
  //     doc.setFontSize(10);
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setTextColor(0, 0, 0);
  //     doc.text(quotationData.clientName, 15, yPos);
  //     yPos += 6;

  //     // ✅ Client Address (Verdana Normal)
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setTextColor(0, 0, 0);
  //     const addressMaxWidth = 90;
  //     const lineHeight = 6;

  //     (quotationData.clientAddress || '').split('\n').forEach(line => {
  //       const wrappedLines = doc.splitTextToSize(line.trim(), addressMaxWidth);
  //       wrappedLines.forEach(wrappedLine => {
  //         doc.text(wrappedLine, 15, yPos);
  //         yPos += lineHeight;
  //       });
  //     });

  //     yPos += 0;

  //     // ✅ Services heading (Verdana Bold)
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setFontSize(15);
  //     doc.setTextColor(0, 0, 0);
  //     doc.text('Services', 105, yPos, { align: 'center' });

  //     // Underline
  //     const textWidth = doc.getTextWidth('Services');
  //     const xStart = 105 - textWidth / 2;
  //     const yLine = yPos + 1.5;
  //     doc.line(xStart, yLine, xStart + textWidth, yLine);

  //     yPos += 8;

  //     // ✅ IMPROVED: Better page space checking function
  //     const checkPageSpace = (requiredSpace) => {
  //       // More accurate calculation considering footer space
  //       if (yPos + requiredSpace > footerStartY) {
  //         doc.addPage();
  //         addHeaderAndLogo();
  //         // ✅ FIXED: Proper yPos calculation for new page considering multi-line titles
  //         const titleLines = doc.splitTextToSize(quotationData.title || 'Website design and CRM Quote', 120);
  //         yPos = 58 + (titleLines.length > 1 ? (titleLines.length - 1) * 7 : 0);
  //         return true;
  //       }
  //       return false;
  //     };

  //     // ✅ Function to estimate text height more accurately
  //     const estimateTextHeight = (text, maxWidth, fontSize = 10) => {
  //       doc.setFontSize(fontSize);
  //       const lines = doc.splitTextToSize(text, maxWidth);
  //       return lines.length * 6; // 6 is typical line height
  //     };

  //     // ✅ Function to set font based on content (Rupee symbol check)
  //     const setSmartFont = (text, style = 'normal') => {
  //       if (typeof text === 'string' && text.includes('₹')) {
  //         doc.setFont('NotoSans', style);
  //       } else {
  //         if (style === 'bold') {
  //           doc.setFont('VerdanaBold', 'normal');
  //         } else {
  //           doc.setFont('Verdana', 'normal');
  //         }
  //       }
  //     };

  //     let tableData = [];

  //     // Add the header row
  //     tableData.push([
  //       {
  //         content: 'Estimated Cost',
  //         colSpan: 3,
  //         styles: {
  //           halign: 'center',
  //           fillColor: [51, 85, 163],
  //           textColor: [255, 255, 255],
  //           fontStyle: 'normal',
  //           fontSize: 11,
  //           font: 'VerdanaBold',
  //         }
  //       }
  //     ]);

  //     let serialNumber = 1;
  //     let grandTotal = 0;
  //     const partTotals = {};

  //     // Loop through all parts dynamically
  //     quotationData.parts.forEach((part, partIndex) => {
  //       const partLetter = String.fromCharCode(65 + partIndex);
  //       let partTotal = 0;

  //       // Add part header
  //       tableData.push([
  //         { 
  //           content: `Part ${partLetter} – ${part.title}`, 
  //           colSpan: 3, 
  //           styles: { 
  //             halign: 'left', 
  //             fontStyle: 'normal', 
  //             fontSize: 10,
  //             font: 'VerdanaBold',
  //           } 
  //         }
  //       ]);

  //       // Add items for this part
  //       part.items.forEach(item => {
  //         tableData.push([
  //           {
  //             content: `${serialNumber++}`,
  //             styles: { font: 'Verdana' }
  //           },
  //           {
  //             content: item.description,
  //             styles: { font: 'Verdana' }
  //           },
  //           {
  //             content: `₹ ${item.amount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
  //             styles: { 
  //               halign: 'right', 
  //               fontSize: 9.5,
  //               font: 'NotoSans',
  //               cellPadding: { top: 2, right: 2, bottom: 2, left: 2 } 
  //             }
  //           }
  //         ]);
  //         partTotal += item.amount;
  //       });

  //       // Add part total row
  //       tableData.push([
  //         {
  //           content: '',
  //           styles: { font: 'Verdana' }
  //         },
  //         {
  //           content: `${partLetter} – Total`,
  //           styles: {
  //             halign: 'right',
  //             fontStyle: 'normal',
  //             font: 'Verdana',
  //             fillColor: [240, 248, 255]
  //           }
  //         },
  //         {
  //           content: `₹ ${partTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
  //           styles: {
  //             halign: 'right',
  //             fontStyle: 'normal',
  //             font: 'NotoSans',
  //             fillColor: [240, 248, 255],
  //           }
  //         }
  //       ]);

  //       partTotals[partLetter] = partTotal;
  //       grandTotal += partTotal;
  //     });

  //     // Generate the total label dynamically
  //     const partLetters = Object.keys(partTotals);
  //     const totalLabel = `Total (${partLetters.join('+')})`;

  //     // Add grand total row
  //     tableData.push([
  //       {
  //         content: '',
  //         styles: { font: 'Verdana' }
  //       },
  //       {
  //         content: totalLabel,
  //         styles: {
  //           halign: 'right',
  //           fontStyle: 'normal',
  //           font: 'VerdanaBold',
  //         }
  //       },
  //       {
  //         content: `₹ ${grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
  //         styles: {
  //           halign: 'right',
  //           fontStyle: 'normal',
  //           font: 'NotoSans',
  //         }
  //       }
  //     ]);

  //     autoTable(doc, {
  //       startY: yPos,
  //       body: tableData,
  //       theme: 'grid',
  //       styles: {
  //         fontSize: 9.5,
  //         textColor: [0, 0, 0],
  //         cellPadding: 3,
  //         lineColor: [0, 0, 0],
  //         lineWidth: 0.5,
  //         fontStyle: 'normal',
  //         font: 'Verdana',
  //       },
  //       headStyles: {
  //         font: 'VerdanaBold',
  //         fontStyle: 'normal',
  //         lineColor: [0, 0, 0],
  //         lineWidth: 0.5,
  //       },
  //       bodyStyles: {
  //         font: 'Verdana',
  //         lineColor: [0, 0, 0],
  //         lineWidth: 0.5,
  //       },
  //       columnStyles: {
  //         0: { cellWidth: 20, halign: 'center' },
  //         1: { cellWidth: 130, halign: 'left' },
  //         2: { cellWidth: 35, halign: 'right' }
  //       },
  //       margin: { left: 15, right: 15 },
  //       didParseCell: data => {
  //         const cell = data.cell.text?.[0];
  //         if (/^[A-Z] – Total$/.test(cell)) {
  //           data.cell.styles.fillColor = [240, 248, 255];
  //           data.cell.styles.fontStyle = 'normal';
  //           data.cell.styles.font = 'VerdanaBold';
  //         }
  //         if ((cell?.startsWith('Total (') || cell === 'Total') && data.column.index > 0) {
  //           data.cell.styles.fontStyle = 'normal';
  //           data.cell.styles.font = 'VerdanaBold';
  //         }
  //         if (cell?.includes('₹')) {
  //           data.cell.styles.font = 'NotoSans';
  //         }
  //       },
  //       didDrawPage: function(data) {
  //         // ✅ FIXED: Add header and footer to each new page created by autoTable
  //         if (data.pageNumber > 1) {
  //           addHeaderAndLogo();
  //         }
  //       },
  //       didDrawCell: function (data) {
  //         if (data.row.index === 0 && data.column.index === 0) {
  //           const pageWidth = doc.internal.pageSize.getWidth();
  //           doc.addImage(
  //             'img/newHeader.jpg',
  //             'JPEG',
  //             data.cell.x,
  //             data.cell.y,
  //             pageWidth - 25,
  //             10.5
  //           );

  //           doc.setFontSize(15);
  //           doc.setTextColor(255, 255, 255);
  //           doc.setFont("VerdanaBold", "normal");

  //           const text = 'Estimated Cost';
  //           const textX = data.cell.x + 90;
  //           const textY = data.cell.y + 7;
  //           doc.text(text, textX, textY, "center");
  //         }
  //       }
  //     });

  //     // ✅ FIXED: Get the final Y position and ensure proper spacing
  //     yPos = doc.lastAutoTable.finalY + 10;

  //     // ✅ Note section (Verdana except for rupee)
  //     checkPageSpace(15);
  //     doc.setFillColor(255, 255, 0);

  //     const noteText = `Note: ${quotationData.note}`;
  //     const noteWidth = doc.getTextWidth(noteText);

  //     // Reduced padding (was +6, now +2 or +3)
  //     doc.rect(15, yPos - 3, noteWidth + 30, 8, 'F')
  //     doc.setFontSize(10);
  //     setSmartFont(noteText, 'bold');
  //     doc.setTextColor(0, 0, 0);
  //     doc.text(noteText, 18, yPos + 2);
  //     yPos += 12;

  //     // ✅ Validity (Verdana)
  //     checkPageSpace(10);
  //     doc.setFontSize(10);
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setTextColor(0, 0, 0);
  //     doc.text('Validity:', 18, yPos);
  //     doc.setFont('Verdana', 'normal');
  //     doc.text(quotationData.validity || 'This quotation is valid for 30 days from the date of issue.', 37, yPos);
  //     yPos += 6;

  //     // ✅ Timeline (Verdana)
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.text('Timeline:', 18, yPos);
  //     doc.setFont('Verdana', 'normal');
  //     doc.text('Estimated project duration: 2-3 weeks from the start date.', 37, yPos);
  //     yPos += 10;

  //     // ✅ Payment Terms (Verdana)
  //     checkPageSpace(50); // Reduced from 30 to allow more flexibility
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setFontSize(12);
  //     doc.text('PAYMENT TERMS', 18, yPos);

  //     doc.setLineWidth(0.5);
  //     doc.line(18, yPos + 1, 55, yPos + 1);
  //     yPos += 8;

  //     doc.setFont('Verdana', 'normal');
  //     doc.setFontSize(10);
  //     const paymentPoints = [
  //       '50% Advance Payment: To initiate the project.',
  //       '30% Payment: Upon completion of the Configuration.',
  //       '20% Payment: After final sign-off.'
  //     ];

  //     paymentPoints.forEach((point) => {
  //       // ✅ IMPROVED: More accurate space calculation for payment terms
  //       const estimatedHeight = estimateTextHeight(`• ${point}`, 170);
  //       checkPageSpace(estimatedHeight + 2);

  //       const bullet = `• ${point}`;
  //       const lines = doc.splitTextToSize(bullet, 170);
  //       doc.text(lines, 22, yPos);
  //       yPos += lines.length * 6;
  //     });

  //     // ✅ IMPROVED: Features section with better space management
  //     if (quotationData.featureCategories?.length) {
  //       quotationData.featureCategories.forEach((cat, index) => {
  //         const features = cat.featuresText?.split('\n').filter(f => f.trim()) || cat.features || [];
  //         if (!features.length) return;

  //         yPos += 6;

  //         // ✅ IMPROVED: Calculate actual space needed for this feature section
  //         const sectionTitle = (cat.name || `FEATURE ${index + 1}`).toUpperCase();
  //         let totalSectionHeight = 16; // Title + spacing

  //         // Calculate height needed for all features in this section
  //         features.forEach((feature) => {
  //           const featureHeight = estimateTextHeight(`• ${feature}`, 160);
  //           totalSectionHeight += featureHeight + 2; // +2 for spacing
  //         });

  //         // ✅ IMPROVED: Only move to new page if the ENTIRE section won't fit
  //         const spaceNeeded = totalSectionHeight + 10; // +10 for safety margin

  //         // Check if we need a new page for this entire section
  //         if (yPos + spaceNeeded > footerStartY) {
  //           doc.addPage();
  //           addHeaderAndLogo();
  //           const titleLines = doc.splitTextToSize(quotationData.title || 'Website design and CRM Quote', 120);
  //           yPos = 58 + (titleLines.length > 1 ? (titleLines.length - 1) * 7 : 0);
  //           yPos += 6; // Add the spacing we removed above
  //         }

  //         const x = 18;

  //         doc.setFont('VerdanaBold', 'normal');
  //         doc.setFontSize(12);
  //         doc.text(sectionTitle, x, yPos);

  //         const textWidth = doc.getTextWidth(sectionTitle);
  //         doc.setLineWidth(0.5);
  //         doc.line(x, yPos + 1, x + textWidth, yPos + 1);
  //         yPos += 8;

  //         doc.setFont('Verdana', 'normal');
  //         doc.setFontSize(10);

  //         // ✅ IMPROVED: Individual feature items with minimal space checking
  //         features.forEach((feature) => {
  //           // Only check space for individual features if they're very long
  //           const featureHeight = estimateTextHeight(`• ${feature}`, 160);
  //           if (featureHeight > 20) { // Only check for very long features
  //             checkPageSpace(featureHeight + 5);
  //           }

  //           const bulletText = `• ${feature}`;
  //           const lines = doc.splitTextToSize(bulletText, 160);
  //           doc.text(lines, 20, yPos);
  //           yPos += lines.length * 6;
  //         });

  //         yPos += 3;
  //       });
  //     }

  //     // ✅ Ensure footer is added to the final page if content was added after table
  //     const currentPage = doc.getCurrentPageInfo().pageNumber;
  //     const totalPages = doc.getNumberOfPages();

  //     if (currentPage === totalPages) {
  //       addFooter();
  //     }

  //     doc.save(`quotation-${quotationData.clientName.replace(/[^a-zA-Z0-9]/g, '_')}.pdf`);
  //   } catch (err) {
  //     console.error('PDF generation error:', err);
  //     alert('Something went wrong while generating PDF.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };
//kavana-july-22
  // const handleGeneratePDF = async () => {
  //   if (!quotationData.clientName) {
  //     alert('Please add client name before generating PDF');
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const doc = new jsPDF();
  //     const pageHeight = 297;
  //     const usableHeight = pageHeight - 60; // More conservative footer space
  //     const footerStartY = 275; // Footer starts at this Y position

  //     // ✅ Load custom fonts
  //     doc.addFileToVFS("NotoSans.ttf", notoSansBase64);
  //     doc.addFont("NotoSans.ttf", "NotoSans", "normal");
  //     doc.addFont("NotoSans.ttf", "NotoSans", "bold");

  //     doc.addFileToVFS("Verdana.ttf", verdanaFont);
  //     doc.addFont("Verdana.ttf", "Verdana", "normal");

  //     doc.addFileToVFS("VerdanaBold.ttf", verdanaboldFont);
  //     doc.addFont("VerdanaBold.ttf", "VerdanaBold", "normal");
  //     doc.addFileToVFS("NotoSansBold.ttf", notoSansboldBase64); // Add your Noto Sans Bold base64 here
  //     doc.addFont("NotoSansBold.ttf", "NotoSansBold", "normal");
  //     // ✅ Function to add footer to any page
  //     const addFooter = () => {
  //       doc.setFontSize(8);
  //       doc.setTextColor(0, 0, 0);
  //       doc.setFont("Verdana", "normal");

  //       // Left side - Address and Phone
  //       doc.text('B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,', 15, 278);
  //       doc.text('Mahadevapura Post Bangalore – 560048', 15, 283);
  //       doc.text('Phone: +91 (636) 465 7660, +91 (990) 050 2404', 15, 288);

  //       // Right side - Email and Website
  //       doc.text('Email: info@excerptech.com', 150, 278);
  //       doc.text('Website: www.excerptech.com', 150, 283);

  //       // ✅ Footer image below footer text
  //       doc.addImage('/img/newHeader.jpg', 'JPEG', 0, 290, 240, 25);
  //     };

  //     // ✅ Function to add header and logo to any page
  //     // const addHeaderAndLogo = () => {
  //     //   // ✅ RESTORED: Top header image
  //     //   doc.addImage('/img/newHeader.jpg', 'JPEG', 0, 0, 210, 8);

  //     //   // Logo positioning - moved down to accommodate header image
  //     //   const logoWidth = 42.5;
  //     //   const logoHeight = 18;
  //     //   const logoY = 13; // Moved down from top due to header image

  //     //   // Left and right logos
  //     //   doc.addImage('img/log1.png', 'PNG', 5, logoY, logoWidth, logoHeight);
  //     //   doc.addImage('img/logo2.png', 'PNG', 210 - 8 - logoWidth, logoY, logoWidth, logoHeight);

  //     //   // ✅ Title with proper text wrapping and positioning
  //     //   const titleY = logoY + logoHeight / 2;
  //     //   doc.setFont('VerdanaBold', 'normal');
  //     //   doc.setFontSize(18);
  //     //   doc.setTextColor(0, 0, 0);

  //     //   const title = quotationData.title || 'Website design and CRM Quote';
  //     //   const maxTitleWidth = 120; // Available width for title (considering logos on both sides)

  //     //   // Split title into lines if too long
  //     //   const titleLines = doc.splitTextToSize(title, maxTitleWidth);

  //     //   // Calculate starting Y position for multi-line titles
  //     //   let titleStartY = titleY;
  //     //   if (titleLines.length > 1) {
  //     //     titleStartY = titleY - ((titleLines.length - 1) * 3); // Adjust for multiple lines
  //     //   }

  //     //   // Draw each line of the title
  //     //   titleLines.forEach((line, index) => {
  //     //     doc.text(line, 105, titleStartY + (index * 7), { align: 'center' });
  //     //   });

  //     //   // ✅ Add footer to every page when header is added
  //     //   addFooter();
  //     // };

  //     let yPos = 0;
  //     const addHeaderAndLogo = () => {
  //       doc.addImage('/img/newHeader.jpg', 'JPEG', 0, 0, 210, 8);

  //       const logoWidth = 42.5;
  //       const logoHeight = 18;
  //       const logoY = 15;

  //       // Left logo
  //       doc.addImage('img/log1.png', 'PNG', 5, logoY, logoWidth, logoHeight);

  //       // ✅ Right logo (fixed width issue)
  //       doc.addImage('img/logo2.png', 'PNG', 210 - 8 - logoWidth, logoY, logoWidth, logoHeight);

  //       const title = quotationData.title || 'Website design and CRM Quote';
  //       const maxTitleWidth = 120;
  //       const titleLines = doc.splitTextToSize(title, maxTitleWidth);
  //       const titleY = logoY + logoHeight / 2 + 5;

  //       let titleStartY = titleY;
  //       if (titleLines.length > 1) {
  //         titleStartY = titleY - ((titleLines.length - 1) * 3);
  //       }

  //       doc.setFont('VerdanaBold', 'normal');
  //       doc.setFontSize(17);
  //       doc.setTextColor(0, 0, 0);
  //       titleLines.forEach((line, index) => {
  //         doc.text(line, 105, titleStartY + (index * 7), { align: 'center' });
  //       });

  //       // ✅ Set yPos globally here based on title
  //       yPos = titleStartY + (titleLines.length * 10) + 6;

  //       addFooter();
  //     };


  //     // ✅ Add header and footer to first page
  //     addHeaderAndLogo();

  //     //let yPos = 18 + 18 + 2; // logoY + logoHeight + spacing

  //     // ✅ Adjust yPos if title is multi-line
  //     const title = quotationData.title || 'Website design and CRM Quote';
  //     const maxTitleWidth = 120;
  //     const titleLines = doc.splitTextToSize(title, maxTitleWidth);
  //     if (titleLines.length > 1) {
  //       yPos += (titleLines.length - 1) * 7;
  //     }

  //     // ✅ Client Name (Verdana Bold)
  //     doc.setFontSize(11);
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setTextColor(0, 0, 0);
  //     doc.text(quotationData.clientName, 25, yPos);
  //     yPos += 4;

  //     // ✅ Client Address (Verdana Normal)
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setTextColor(0, 0, 0);
  //     const addressMaxWidth = 90;
  //     const lineHeight = 4;

  //     (quotationData.clientAddress || '').split('\n').forEach(line => {
  //       const wrappedLines = doc.splitTextToSize(line.trim(), addressMaxWidth);
  //       wrappedLines.forEach(wrappedLine => {
  //         doc.text(wrappedLine, 25, yPos);
  //         yPos += lineHeight;
  //       });
  //     });

  //     yPos += 0;

  //     // ✅ Services heading (Verdana Bold)
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setFontSize(11);
  //     doc.setTextColor(0, 0, 0);
  //     doc.text('Services', 100, yPos, { align: 'center' });

  //     // Underline
  //     const textWidth = doc.getTextWidth('Services');
  //     const xStart = 100 - textWidth / 2;
  //     const yLine = yPos + 0.6;
  //     doc.line(xStart, yLine, xStart + textWidth, yLine);

  //     yPos += 8;

  //     // ✅ IMPROVED: Better page space checking function
  //     const checkPageSpace = (requiredSpace) => {
  //       // More accurate calculation considering footer space
  //       if (yPos + requiredSpace > footerStartY) {
  //         doc.addPage();
  //         addHeaderAndLogo();
  //         // ✅ FIXED: Proper yPos calculation for new page considering multi-line titles
  //         const titleLines = doc.splitTextToSize(quotationData.title || 'Website design and CRM Quote', 120);
  //         yPos = 58 + (titleLines.length > 1 ? (titleLines.length - 1) * 7 : 0);
  //         return true;
  //       }
  //       return false;
  //     };

  //     // ✅ Function to estimate text height more accurately
  //     const estimateTextHeight = (text, maxWidth, fontSize = 10) => {
  //       doc.setFontSize(fontSize);
  //       const lines = doc.splitTextToSize(text, maxWidth);
  //       return lines.length * 6; // 6 is typical line height
  //     };

  //     // ✅ Function to set font based on content (Rupee symbol check)
  //     const setSmartFont = (text, style = 'normal') => {
  //       if (typeof text === 'string' && text.includes('₹')) {
  //         doc.setFont('NotoSans', style);
  //       } else {
  //         if (style === 'bold') {
  //           doc.setFont('VerdanaBold', 'normal');
  //         } else {
  //           doc.setFont('Verdana', 'normal');
  //         }
  //       }
  //     };

  //     let tableData = [];

  //     // Add the header row
  //     tableData.push([
  //       {
  //         content: 'Estimated Cost',
  //         colSpan: 3,
  //         styles: {
  //           halign: 'center',
  //           fillColor: [51, 85, 163],
  //           textColor: [255, 255, 255],
  //           fontStyle: 'normal',
  //           fontSize: 15,
  //           font: 'VerdanaBold',
  //         }
  //       }
  //     ]);

  //     let serialNumber = 1;
  //     let grandTotal = 0;
  //     const partTotals = {};

  //     // Loop through all parts dynamically
  //     quotationData.parts.forEach((part, partIndex) => {
  //       const partLetter = String.fromCharCode(65 + partIndex);
  //       let partTotal = 0;

  //       // Add part header
  //       tableData.push([
  //         {
  //           content: `Part ${partLetter} – ${part.title}`,
  //           colSpan: 3,
  //           styles: {
  //             halign: 'left',
  //             fontStyle: 'normal',
  //             fontSize: 10,
  //             font: 'VerdanaBold',
  //           }
  //         }
  //       ]);

  //       // Add items for this part
  //       part.items.forEach(item => {
  //         tableData.push([
  //           {
  //             content: `${serialNumber++}`,
  //             styles: { font: 'Verdana' }
  //           },
  //           {
  //             content: item.description,
  //             styles: { font: 'Verdana' }
  //           },
  //           {
  //             content: `₹ ${item.amount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
  //             styles: {
  //               halign: 'right',
  //               fontSize: 9.5,
  //               font: 'NotoSans',
  //               cellPadding: { top: 2, right: 2, bottom: 2, left: 2 }
  //             }
  //           }
  //         ]);
  //         partTotal += item.amount;
  //       });

  //       // Add part total row
  //       tableData.push([
  //         {
  //           content: '',
  //           styles: { font: 'Verdana' }
  //         },
  //         {
  //           content: `${partLetter} – Total`,
  //           styles: {
  //             halign: 'right',
  //             fontStyle: 'normal',
  //             font: 'VerdanaBold',
  //             fillColor: [240, 248, 255]
  //           }
  //         },
  //         {
  //           content: `₹${partTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
  //           styles: {
  //             halign: 'right',
  //             fontStyle: 'normal',
  //             font: 'NotoSans',
  //             fillColor: [240, 248, 255],
  //           }
  //         }
  //       ]);

  //       partTotals[partLetter] = partTotal;
  //       grandTotal += partTotal;
  //     });

  //     // Generate the total label dynamically
  //     const partLetters = Object.keys(partTotals);
  //     const totalLabel = `Total (${partLetters.join('+')})`;

  //     // Add grand total row
  //     tableData.push([
  //       {
  //         content: '',
  //         styles: { font: 'Verdana' }
  //       },
  //       {
  //         content: totalLabel,
  //         styles: {
  //           halign: 'right',
  //           fontStyle: 'normal',
  //           font: 'VerdanaBold',
  //         }
  //       },
  //       {
  //         content: `₹ ${grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
  //         styles: {
  //           halign: 'right',
  //           fontStyle: 'normal',
  //           font: 'NotoSansBold',
  //         }
  //       }
  //     ]);

  //     // Add this function before your autoTable call
  //     // const drawCustomTotal = (doc, amount, x, y, cellWidth, cellHeight, isGrandTotal = false) => {
  //     //   const fontSize = isGrandTotal ? 11 : 10.5;
  //     //   const rupeeSymbol = '₹';
  //     //   const numberPart = amount.replace('₹', '').trim();

  //     //   // Calculate positioning for right alignment
  //     //   const cellCenterY = y + cellHeight / 2 + 1.5;
  //     //   const rightMargin = 5; // Space from right edge

  //     //   // Measure text widths
  //     //   doc.setFont('NotoSans', 'normal');
  //     //   doc.setFontSize(fontSize);
  //     //   const rupeeWidth = doc.getTextWidth(rupeeSymbol);

  //     //   doc.setFont('VerdanaBold', 'normal');
  //     //   doc.setFontSize(fontSize);
  //     //   const numberWidth = doc.getTextWidth(numberPart);

  //     //   // Calculate positions for right alignment
  //     //   const totalWidth = rupeeWidth + numberWidth + 2; // +2 for small space between ₹ and number
  //     //   const startX = x + cellWidth - totalWidth - rightMargin;

  //     //   // Draw ₹ symbol with NotoSans
  //     //   doc.setFont('NotoSans', 'normal');
  //     //   doc.setFontSize(fontSize);
  //     //   doc.setTextColor(0, 0, 0);
  //     //   doc.text(rupeeSymbol, startX, cellCenterY);

  //     //   // Draw number with VerdanaBold
  //     //   doc.setFont('VerdanaBold', 'normal');
  //     //   doc.setFontSize(fontSize);
  //     //   doc.setTextColor(0, 0, 0);
  //     //   doc.text(numberPart, startX + rupeeWidth + 2, cellCenterY);
  //     // };


  //     // const drawCustomTotal = (doc, amount, x, y, cellWidth, cellHeight, isGrandTotal = false) => {
  //     //   const fontSize = isGrandTotal ? 11 : 10.5;
  //     //   const rupeeSymbol = '₹';
  //     //   const numberPart = amount.replace('₹', '').trim();

  //     //   // Calculate positioning for right alignment
  //     //   const cellCenterY = y + cellHeight / 2 + 1.5;
  //     //   const rightMargin = 5;

  //     //   // Measure text widths
  //     //   doc.setFont('NotoSans', 'normal');
  //     //   doc.setFontSize(fontSize);
  //     //   const rupeeWidth = doc.getTextWidth(rupeeSymbol);

  //     //   doc.setFont('VerdanaBold', 'normal');
  //     //   doc.setFontSize(fontSize);
  //     //   const numberWidth = doc.getTextWidth(numberPart);

  //     //   const totalWidth = rupeeWidth + numberWidth + 2;
  //     //   const startX = x + cellWidth - totalWidth - rightMargin;

  //     //   // === ✅ Only for GRAND TOTAL: Draw Blue → Pink gradient ===
  //     //   if (isGrandTotal) {
  //     //     const steps = 30; // More steps = smoother gradient
  //     //     for (let i = 0; i < steps; i++) {
  //     //       const ratio = i / (steps - 1);
  //     //       const r = Math.round(110 * (1 - ratio) + 247 * ratio); // R: blue to pink
  //     //       const g = Math.round(168 * (1 - ratio) + 138 * ratio); // G
  //     //       const b = Math.round(254 * (1 - ratio) + 203 * ratio); // B

  //     //       doc.setFillColor(r, g, b);
  //     //       doc.rect(x + (cellWidth * ratio), y, cellWidth / steps + 0.5, cellHeight, 'F');
  //     //     }
  //     //   }

  //     //   // === ₹ Symbol ===
  //     //   doc.setFont('NotoSans', 'normal');
  //     //   doc.setFontSize(fontSize);
  //     //   doc.setTextColor(0, 0, 0);
  //     //   doc.text(rupeeSymbol, startX, cellCenterY);

  //     //   // === Number Part ===
  //     //   doc.setFont('VerdanaBold', 'normal');
  //     //   doc.setFontSize(fontSize);
  //     //   doc.setTextColor(0, 0, 0);
  //     //   doc.text(numberPart, startX + rupeeWidth + 2, cellCenterY);
  //     // };

  //     const drawCustomTotal = (doc, amount, x, y, cellWidth, cellHeight, isGrandTotal = false) => {
  //       const fontSize = isGrandTotal ? 11 : 10.5;
  //       const rupeeSymbol = '₹';
  //       const numberPart = amount.replace('₹', '').trim();

  //       const cellCenterY = y + cellHeight / 2 + 1.5;
  //       const rightMargin = 5;

  //       doc.setFont('NotoSans', 'normal');
  //       doc.setFontSize(fontSize);
  //       const rupeeWidth = doc.getTextWidth(rupeeSymbol);

  //       doc.setFont('VerdanaBold', 'normal');
  //       doc.setFontSize(fontSize);
  //       const numberWidth = doc.getTextWidth(numberPart);

  //       const totalWidth = rupeeWidth + numberWidth + 2;
  //       const startX = x + cellWidth - totalWidth - rightMargin;

  //       // 🟦➡️🎀 Only for GRAND TOTAL: Simulate Gradient safely
  //       if (isGrandTotal) {
  //         const steps = 45; // fewer steps = bigger slices
  //         const sliceWidth = cellWidth / steps;

  //         for (let i = 0; i < steps; i++) {
  //           const ratio = i / (steps - 1);
  //           const r = Math.round(0x00 + (0xEC - 0x00) * ratio);
  //           const g = Math.round(0x47 + (0x6E - 0x47) * ratio);
  //           const b = Math.round(0xAB + (0xAD - 0xAB) * ratio);

  //           doc.setFillColor(r, g, b);
  //           doc.rect(x + (sliceWidth * i), y, sliceWidth, cellHeight, 'F');
  //         }
  //       }

  //       // ₹ Symbol
  //       doc.setFont('NotoSans', 'normal');
  //       doc.setFontSize(fontSize);

  //       if(isGrandTotal){
  //         doc.setTextColor(255,255,255)
  //       }else{
  //       doc.setTextColor(0, 0, 0)
  //       };

  //       doc.text(rupeeSymbol, startX, cellCenterY);

  //       // Number Part
  //       doc.setFont('VerdanaBold', 'normal');
  //       doc.setFontSize(fontSize);
  //       if(isGrandTotal){doc.setTextColor(255,255,255)}else{
  //       doc.setTextColor(0, 0, 0)};
  //       doc.text(numberPart, startX + rupeeWidth + 2, cellCenterY);
  //     };





  //     // Replace your existing didParseCell and didDrawCell functions with this:
  //     autoTable(doc, {
  //       startY: yPos,
  //       body: tableData,
  //       theme: 'grid',
  //       styles: {
  //         fontSize: 9.5,
  //         textColor: [0, 0, 0],
  //         cellPadding: 2.5,
  //         lineColor: [0, 0, 0],
  //         lineWidth: 0.1,
  //         fontStyle: 'normal',
  //         font: 'Verdana',
  //       },
  //       headStyles: {
  //         font: 'VerdanaBold',
  //         fontStyle: 'normal',
  //         lineColor: [0, 0, 0],
  //         lineWidth: 0.1,
  //       },
  //       bodyStyles: {
  //         font: 'Verdana',
  //         lineColor: [0, 0, 0],
  //         lineWidth: 0.1,
  //       },
  //       columnStyles: {
  //         0: { cellWidth: 10, halign: 'center' },
  //         1: { cellWidth: 110, halign: 'left' },
  //         2: { cellWidth: 32, halign: 'right' }
  //       },
  //       margin: { left: 25, right: 25 },

  //       didParseCell: (data) => {
  //         const cellText = data.cell.text?.[0];
  //         const rowData = data.row.raw;

  //         // Check if this is a total row by looking at the second column
  //         const secondColumnText = rowData[1]?.content || '';
  //         const isTotalRow = /^[A-Z] – Total$/.test(secondColumnText) ||
  //           secondColumnText.startsWith('Total (') ||
  //           secondColumnText === 'Total';


  //         // if (isTotalRow && data.column.index === 2) {
  //         //   data.cell.raw = cellText;

  //         //   data.cell.text = [''];
  //         //   data.cell.styles.fillColor = secondColumnText.startsWith('Total ') ? [255, 255, 255] : [230, 240, 255];

  //         // }

  //         // if (isTotalRow && data.column.index === 2) {
  //         //   const secondColumnText = data.row.raw[1]?.content || '';
  //         //   const raw = data.cell.raw;
  //         //   const amountText =
  //         //     typeof raw === 'object' && raw !== null && 'content' in raw
  //         //       ? raw.content
  //         //       : typeof raw === 'string'
  //         //         ? raw
  //         //         : '';
  //         //   console.log(amountText)
  //         //   const isTotalRow = /^[A-Z] – Total$/.test(secondColumnText) ||
  //         //     secondColumnText.startsWith('Total (') ||
  //         //     secondColumnText === 'Total';

  //         //   const isGrandTotal = secondColumnText.startsWith('Total (') || secondColumnText === 'Total';

  //         //   if (isTotalRow && amountText && amountText.includes('₹')) {
  //         //     drawCustomTotal(doc, amountText, data.cell.x, data.cell.y, data.cell.width, data.cell.height, isGrandTotal);
  //         //   }
  //         // }


  //         // Regular items with ₹ symbols (not total rows)
  //         // if (cellText?.includes('₹') && !isTotalRow) {
  //         //   data.cell.styles.font = 'NotoSans';
  //         // }
  //         if (cellText?.includes('₹')) {
  //           if (isTotalRow) {
  //             // Hide autoTable’s default text rendering
  //             data.cell.text = [''];
  //           } else {
  //             // Use custom font for ₹ values
  //             data.cell.styles.font = 'NotoSans';
  //           }
  //         }

  //       },

  //       didDrawPage: function (data) {
  //         if (data.pageNumber > 1) {
  //           addHeaderAndLogo();
  //         }
  //       },

  //       didDrawCell: function (data) {
  //         // Header cell with image
  //         if (data.row.index === 0 && data.column.index === 0) {
  //           doc.addImage(
  //             'img/newHeader.jpg',
  //             'JPEG',
  //             data.cell.x,
  //             data.cell.y,
  //             152,
  //             10.5
  //           );

  //           doc.setFontSize(10);
  //           doc.setTextColor(250, 250, 250);
  //           doc.setFont("VerdanaBold");

  //           const text = 'Estimated Cost';
  //           const textX = data.cell.x + 60.5;
  //           const textY = data.cell.y + 7;
  //           doc.text(text, textX, textY);
  //         }

  //         // Custom drawing for total rows
  //         if (data.column.index === 2) { // Amount column
  //           const secondColumnText = data.row.raw[1]?.content || '';
  //           const raw = data.cell.raw;
  //           const amountText =
  //             typeof raw === 'object' && raw !== null && 'content' in raw
  //               ? raw.content
  //               : typeof raw === 'string'
  //                 ? raw
  //                 : ''; // Get the original amount text we stored

  //           // Check if this is a total row and has amount text
  //           const isTotalRow = /^[A-Z] – Total$/.test(secondColumnText) ||
  //             secondColumnText.startsWith('Total (') ||
  //             secondColumnText === 'Total';

  //           if (isTotalRow && amountText && amountText.includes('₹')) {
  //             const isGrandTotal = secondColumnText.startsWith('Total (') || secondColumnText === 'Total';
  //             drawCustomTotal(doc, amountText, data.cell.x, data.cell.y, data.cell.width, data.cell.height, isGrandTotal);
  //           }
  //         }
  //       }
  //     });

  //     // ✅ Get the final Y position and ensure proper spacing
  //     yPos = doc.lastAutoTable.finalY + 10;

  //     // ✅ Note section (Verdana except for rupee)
  //     // ✅ Note section (Verdana except for rupee)
  //     checkPageSpace(15);
  //     doc.setFillColor(255, 255, 0);

  //     const noteText = `Note : ${quotationData.note}`;

  //     // Set font and size first to get accurate width
  //     doc.setFontSize(10);
  //     setSmartFont(noteText, 'bold');
  //     const noteWidth = doc.getTextWidth(noteText);

  //     // Background rectangle with proper width (reduced padding from 30 to 6)
  //     doc.rect(25, yPos - 3, noteWidth + 6, 8, 'F');

  //     doc.setTextColor(0, 0, 0);
  //     doc.text(noteText, 25, yPos + 2);
  //     yPos += 12;

  //     // ✅ Validity (Verdana)
  //     checkPageSpace(10);
  //     doc.setFontSize(10);
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setTextColor(0, 0, 0);
  //     doc.text('Validity :', 25, yPos);
  //     doc.setFont('Verdana', 'normal');
  //     doc.text(quotationData.validity || 'This quotation is valid for 30 days from the date of issue.', 44, yPos);
  //     yPos += 6;

  //     // ✅ Timeline (Verdana)
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.text('Timeline :', 25, yPos);
  //     doc.setFont('Verdana', 'normal');
  //     doc.text('Estimated project duration: 2-3 weeks from the start date.', 46, yPos);
  //     yPos += 6;

  //     // ✅ Payment Terms (Verdana)

  //     // ✅ Add a space after the colon
  //     checkPageSpace(10);

  //     const baseX = 25;
  //     let baseY = yPos;
  //     // Print each bullet on a new line with bullet character

  //     if (quotationData.paymentTermsText) {
  //       const paymentTerms = quotationData.paymentTermsText
  //         .split('\n')
  //         .map(line => line.trim())
  //         .filter(line => line); // Remove empty lines

  //       if (paymentTerms.length) {
  //         const bulletX = baseX;
  //         baseY += 0;

  //         doc.setFont('VerdanaBold', 'normal');
  //         doc.setFontSize(10);
  //         doc.text("Payment Terms :", bulletX, baseY);
  //         const titleWidth = doc.getTextWidth("PAYMENT TERMS :");

  //         baseY += 6;

  //         doc.setFont('Verdana', 'normal');
  //         doc.setFontSize(10);

  //         paymentTerms.forEach((term) => {
  //           const lines = doc.splitTextToSize(`• ${term}`, 160);
  //           doc.text(lines, bulletX, baseY);
  //           baseY += lines.length * 6;
  //         });

  //         yPos = baseY + 4;
  //       }
  //     }




  //     // Update yPos after all lines
  //     // yPos = baseY + 4;


  //     if (quotationData.featureCategories?.length) {
  //       quotationData.featureCategories.forEach((cat, index) => {
  //         const features = cat.featuresText?.split('\n').filter(f => f.trim()) || cat.features || [];
  //         if (!features.length) return;

  //         // ✅ Add space only after first section
  //         if (index > 0) yPos += 6;


  //         const sectionTitle = (cat.name || `FEATURE ${index + 1}`).toUpperCase();
  //         let totalSectionHeight = 16;

  //         features.forEach((feature) => {
  //           const featureHeight = estimateTextHeight(`• ${feature}`, 160);
  //           totalSectionHeight += featureHeight + 2;
  //         });

  //         const spaceNeeded = totalSectionHeight + 10;

  //         if (yPos + spaceNeeded > footerStartY) {
  //           doc.addPage();
  //           addHeaderAndLogo();

  //         }

  //         const x = 25;

  //         doc.setFont('VerdanaBold', 'normal');
  //         doc.setFontSize(10);
  //         doc.text(sectionTitle, x, yPos);

  //         const textWidth = doc.getTextWidth(sectionTitle);
  //         doc.setLineWidth(0.5);
  //         doc.line(x, yPos + 1, x + textWidth, yPos + 1);
  //         yPos += 8;

  //         doc.setFont('Verdana', 'normal');
  //         doc.setFontSize(10);

  //         features.forEach((feature) => {
  //           const featureHeight = estimateTextHeight(`• ${feature}`, 160);
  //           if (featureHeight > 20) {
  //             checkPageSpace(featureHeight + 5);
  //           }

  //           const bulletText = `o ${feature}`;
  //           const lines = doc.splitTextToSize(bulletText, 160);
  //           doc.text(lines, 25, yPos);
  //           yPos += lines.length * 6;
  //         });

  //         yPos += 3;
  //       });
  //     }
  //     // ✅ Annual Renewal Section (add this after features section)
  //     // ✅ Annual Renewal Section (add this after features section)
  //     if (quotationData.annualRenewal > 0) {
  //       yPos += 4;

  //       const renewalSectionHeight = 20;
  //       if (yPos + renewalSectionHeight > footerStartY) {
  //         doc.addPage();
  //         addHeaderAndLogo();
  //       }

  //       const x = 25;

  //       // Draw label using VerdanaBold
  //       doc.setFont('VerdanaBold', 'normal');
  //       doc.setFontSize(10);
  //       doc.setTextColor(0, 0, 0);
  //       doc.text('Annual Renewal :', x, yPos);

  //       // Calculate position for amount
  //       const labelWidth = doc.getTextWidth('Annual Renewal : ');
  //       const amountStartX = x + labelWidth;

  //       // Draw ₹ symbol using NotoSans
  //       doc.setFont('NotoSans', 'normal');
  //       doc.setFontSize(10);
  //       doc.text('₹', amountStartX, yPos);

  //       // Draw number using VerdanaBold
  //       const rupeeWidth = doc.getTextWidth('₹');
  //       const numberText = quotationData.annualRenewal.toLocaleString('en-IN', { minimumFractionDigits: 2 });
  //       doc.setFont('VerdanaBold', 'normal');
  //       doc.setFontSize(10);
  //       doc.text(numberText, amountStartX + rupeeWidth, yPos); // +1 for small space

  //       yPos += 8;
  //     }


  //     // ✅ Ensure footer is added to the final page if content was added after table
  //     const currentPage = doc.getCurrentPageInfo().pageNumber;
  //     const totalPages = doc.getNumberOfPages();

  //     if (currentPage === totalPages) {
  //       addFooter();
  //     }

  //     doc.save(`quotation-${quotationData.clientName.replace(/[^a-zA-Z0-9]/g, '_')}.pdf`);
  //   } catch (err) {
  //     console.error('PDF generation error:', err);
  //     alert('Something went wrong while generating PDF.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

const handleGeneratePDF = async () => {
  if (!quotationData.clientName) {
    alert('Please add client name before generating PDF');
    return;
  }

  setLoading(true);

  try {
    const doc = new jsPDF();
    const pageHeight = 297;
    const usableHeight = pageHeight - 60; // More conservative footer space
    const footerStartY = 275; // Footer starts at this Y position

    // ✅ Load custom fonts
    doc.addFileToVFS("NotoSans.ttf", notoSansBase64);
    doc.addFont("NotoSans.ttf", "NotoSans", "normal");
    doc.addFont("NotoSans.ttf", "NotoSans", "bold");

    doc.addFileToVFS("Verdana.ttf", verdanaFont);
    doc.addFont("Verdana.ttf", "Verdana", "normal");

    doc.addFileToVFS("VerdanaBold.ttf", verdanaboldFont);
    doc.addFont("VerdanaBold.ttf", "VerdanaBold", "normal");
    doc.addFileToVFS("NotoSansBold.ttf", notoSansboldBase64); // Add your Noto Sans Bold base64 here
    doc.addFont("NotoSansBold.ttf", "NotoSansBold", "normal");
    
    // ✅ Function to add footer to any page
    const addFooter = () => {
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.setFont("Verdana", "normal");

      // Left side - Address and Phone
      doc.text('B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,', 15, 278);
      doc.text('Mahadevapura Post Bangalore – 560048', 15, 283);
      doc.text('Phone: +91 (636) 465 7660, +91 (990) 050 2404', 15, 288);

      // Right side - Email and Website
      doc.text('Email: info@excerptech.com', 150, 278);
      doc.text('Website: www.excerptech.com', 150, 283);

      // ✅ Footer image below footer text
      doc.addImage('/img/newHeader.jpg', 'JPEG', 0, 290, 240, 25);
    };

    let yPos = 0;
    const addHeaderAndLogo = () => {
      doc.addImage('/img/newHeader.jpg', 'JPEG', 0, 0, 210, 8);

      const logoWidth = 42.5;
      const logoHeight = 18;
      const logoY = 15;

      // Left logo
      doc.addImage('img/log1.png', 'PNG', 5, logoY, logoWidth, logoHeight);

      // ✅ Right logo (fixed width issue)
      doc.addImage('img/logo2.png', 'PNG', 210 - 8 - logoWidth, logoY, logoWidth, logoHeight);

      const title = quotationData.title || 'Website design and CRM Quote';
      const maxTitleWidth = 120;
      const titleLines = doc.splitTextToSize(title, maxTitleWidth);
      const titleY = logoY + logoHeight / 2 + 5;

      let titleStartY = titleY;
      if (titleLines.length > 1) {
        titleStartY = titleY - ((titleLines.length - 1) * 3);
      }

      doc.setFont('VerdanaBold', 'normal');
      doc.setFontSize(17);
      doc.setTextColor(0, 0, 0);
      titleLines.forEach((line, index) => {
        doc.text(line, 105, titleStartY + (index * 7), { align: 'center' });
      });

      // ✅ Set yPos globally here based on title
      yPos = titleStartY + (titleLines.length * 10) + 6;

      addFooter();
    };

    // ✅ Add header and footer to first page
    addHeaderAndLogo();

    // ✅ Adjust yPos if title is multi-line
    const title = quotationData.title || 'Website design and CRM Quote';
    const maxTitleWidth = 120;
    const titleLines = doc.splitTextToSize(title, maxTitleWidth);
    if (titleLines.length > 1) {
      yPos += (titleLines.length - 1) * 7;
    }

    // ✅ Client Name (Verdana Bold)
    doc.setFontSize(11);
    doc.setFont('VerdanaBold', 'normal');
    doc.setTextColor(0, 0, 0);
    doc.text(quotationData.clientName, 25, yPos);
    yPos += 4;

    // ✅ Client Address (Verdana Normal)
    doc.setFont('VerdanaBold', 'normal');
    doc.setTextColor(0, 0, 0);
    const addressMaxWidth = 90;
    const lineHeight = 4;

    (quotationData.clientAddress || '').split('\n').forEach(line => {
      const wrappedLines = doc.splitTextToSize(line.trim(), addressMaxWidth);
      wrappedLines.forEach(wrappedLine => {
        doc.text(wrappedLine, 25, yPos);
        yPos += lineHeight;
      });
    });

    yPos += 0;

    // ✅ Services heading (Verdana Bold)
    doc.setFont('VerdanaBold', 'normal');
    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0);
    doc.text('Services', 100, yPos, { align: 'center' });

    // Underline
    const textWidth = doc.getTextWidth('Services');
    const xStart = 100 - textWidth / 2;
    const yLine = yPos + 0.6;
    doc.line(xStart, yLine, xStart + textWidth, yLine);

    yPos += 8;

    // ✅ IMPROVED: Better page space checking function
    const checkPageSpace = (requiredSpace) => {
      // More accurate calculation considering footer space
      if (yPos + requiredSpace > footerStartY) {
        doc.addPage();
        addHeaderAndLogo();
        // ✅ FIXED: Proper yPos calculation for new page considering multi-line titles
        const titleLines = doc.splitTextToSize(quotationData.title || 'Website design and CRM Quote', 120);
        yPos = 58 + (titleLines.length > 1 ? (titleLines.length - 1) * 7 : 0);
        return true;
      }
      return false;
    };

    // ✅ Function to estimate text height more accurately
    const estimateTextHeight = (text, maxWidth, fontSize = 10) => {
      doc.setFontSize(fontSize);
      const lines = doc.splitTextToSize(text, maxWidth);
      return lines.length * 6; // 6 is typical line height
    };

    // ✅ Function to set font based on content (Rupee symbol check)
    const setSmartFont = (text, style = 'normal') => {
      if (typeof text === 'string' && text.includes('₹')) {
        doc.setFont('NotoSans', style);
      } else {
        if (style === 'bold') {
          doc.setFont('VerdanaBold', 'normal');
        } else {
          doc.setFont('Verdana', 'normal');
        }
      }
    };

    let tableData = [];

    // Add the header row
    tableData.push([
      {
        content: 'Estimated Cost',
        colSpan: 3,
        styles: {
          halign: 'center',
          fillColor: [51, 85, 163],
          textColor: [255, 255, 255],
          fontStyle: 'normal',
          fontSize: 15,
          font: 'VerdanaBold',
        }
      }
    ]);

    let serialNumber = 1;
    let subtotal = 0; // Changed from grandTotal to subtotal
    const partTotals = {};

    // Loop through all parts dynamically
    quotationData.parts.forEach((part, partIndex) => {
      const partLetter = String.fromCharCode(65 + partIndex);
      let partTotal = 0;

      // Add part header
      tableData.push([
        {
          content: `Part ${partLetter} – ${part.title}`,
          colSpan: 3,
          styles: {
            halign: 'left',
            fontStyle: 'normal',
            fontSize: 10,
            font: 'VerdanaBold',
          }
        }
      ]);

      // Add items for this part
      part.items.forEach(item => {
        tableData.push([
          {
            content: `${serialNumber++}`,
            styles: { font: 'Verdana' }
          },
          {
            content: item.description,
            styles: { font: 'Verdana' }
          },
          {
            content: `₹ ${item.amount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
            styles: {
              halign: 'right',
              fontSize: 9.5,
              font: 'NotoSans',
              cellPadding: { top: 2, right: 2, bottom: 2, left: 2 }
            }
          }
        ]);
        partTotal += item.amount;
      });

      // Add part total row
      tableData.push([
        {
          content: '',
          styles: { font: 'Verdana' }
        },
        {
          content: `${partLetter} – Total`,
          styles: {
            halign: 'right',
            fontStyle: 'normal',
            font: 'VerdanaBold',
            fillColor: [240, 248, 255]
          }
        },
        {
          content: `₹${partTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
          styles: {
            halign: 'right',
            fontStyle: 'normal',
            font: 'NotoSans',
            fillColor: [240, 248, 255],
          }
        }
      ]);

      partTotals[partLetter] = partTotal;
      subtotal += partTotal;
    });

    // Generate the subtotal label dynamically
    const partLetters = Object.keys(partTotals);
    const subtotalLabel = `Subtotal (${partLetters.join('+')})`;

    // Add subtotal row
    tableData.push([
      {
        content: '',
        styles: { font: 'Verdana' }
      },
      {
        content: subtotalLabel,
        styles: {
          halign: 'right',
          fontStyle: 'normal',
          font: 'VerdanaBold',
        }
      },
      {
        content: `₹ ${subtotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
        styles: {
          halign: 'right',
          fontStyle: 'normal',
          font: 'NotoSans',
        }
      }
    ]);

    // ✅ Add discount row ONLY if discount exists and is greater than 0
    let discountAmount = 0;
    if (quotationData.discount && quotationData.discount > 0) {
      discountAmount = quotationData.discount;
      
      tableData.push([
        {
          content: '',
          styles: { font: 'Verdana' }
        },
        {
          content: 'Discount',
          styles: {
            halign: 'right',
            fontStyle: 'normal',
            font: 'VerdanaBold',
            fillColor: [255, 240, 240] // Light red background for discount
          }
        },
        {
          content: `- ₹ ${discountAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
          styles: {
            halign: 'right',
            fontStyle: 'normal',
            font: 'NotoSans',
            fillColor: [255, 240, 240], // Light red background for discount
            textColor: [200, 0, 0] // Red text for discount
          }
        }
      ]);
    }

    // ✅ Calculate and add grand total (subtotal - discount)
    const grandTotal = subtotal - discountAmount;
    
    tableData.push([
      {
        content: '',
        styles: { font: 'Verdana' }
      },
      {
        content: 'Grand Total',
        styles: {
          halign: 'right',
          fontStyle: 'normal',
          font: 'VerdanaBold',
        }
      },
      {
        content: `₹ ${grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
        styles: {
          halign: 'right',
          fontStyle: 'normal',
          font: 'NotoSansBold',
        }
      }
    ]);

    const drawCustomTotal = (doc, amount, x, y, cellWidth, cellHeight, isGrandTotal = false, isDiscount = false) => {
      const fontSize = isGrandTotal ? 11 : 10.5;
      const rupeeSymbol = isDiscount ? '- ₹' : '₹';
      const numberPart = amount.replace(/^-?\s*₹\s*/, '').trim();

      const cellCenterY = y + cellHeight / 2 + 1.5;
      const rightMargin = 5;

      doc.setFont('NotoSans', 'normal');
      doc.setFontSize(fontSize);
      const rupeeWidth = doc.getTextWidth(rupeeSymbol);

      doc.setFont('VerdanaBold', 'normal');
      doc.setFontSize(fontSize);
      const numberWidth = doc.getTextWidth(numberPart);

      const totalWidth = rupeeWidth + numberWidth + 2;
      const startX = x + cellWidth - totalWidth - rightMargin;

      // 🟦➡️🎀 Only for GRAND TOTAL: Simulate Gradient safely
      if (isGrandTotal) {
        const steps = 45; // fewer steps = bigger slices
        const sliceWidth = cellWidth / steps;

        for (let i = 0; i < steps; i++) {
          const ratio = i / (steps - 1);
          const r = Math.round(0x00 + (0xEC - 0x00) * ratio);
          const g = Math.round(0x47 + (0x6E - 0x47) * ratio);
          const b = Math.round(0xAB + (0xAD - 0xAB) * ratio);

          doc.setFillColor(r, g, b);
          doc.rect(x + (sliceWidth * i), y, sliceWidth, cellHeight, 'F');
        }
      }

      // ₹ Symbol
      doc.setFont('NotoSans', 'normal');
      doc.setFontSize(fontSize);

      if (isGrandTotal) {
        doc.setTextColor(255, 255, 255);
      } else if (isDiscount) {
        doc.setTextColor(200, 0, 0); // Red color for discount
      } else {
        doc.setTextColor(0, 0, 0);
      }

      doc.text(rupeeSymbol, startX, cellCenterY);

      // Number Part
      doc.setFont('VerdanaBold', 'normal');
      doc.setFontSize(fontSize);
      
      if (isGrandTotal) {
        doc.setTextColor(255, 255, 255);
      } else if (isDiscount) {
        doc.setTextColor(200, 0, 0); // Red color for discount
      } else {
        doc.setTextColor(0, 0, 0);
      }
      
      doc.text(numberPart, startX + rupeeWidth + 2, cellCenterY);
    };

    // Replace your existing didParseCell and didDrawCell functions with this:
    autoTable(doc, {
      startY: yPos,
      body: tableData,
      theme: 'grid',
      styles: {
        fontSize: 9.5,
        textColor: [0, 0, 0],
        cellPadding: 2.5,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        fontStyle: 'normal',
        font: 'Verdana',
      },
      headStyles: {
        font: 'VerdanaBold',
        fontStyle: 'normal',
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      bodyStyles: {
        font: 'Verdana',
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      columnStyles: {
        0: { cellWidth: 10, halign: 'center' },
        1: { cellWidth: 110, halign: 'left' },
        2: { cellWidth: 32, halign: 'right' }
      },
      margin: { left: 25, right: 25 },

      didParseCell: (data) => {
        const cellText = data.cell.text?.[0];
        const rowData = data.row.raw;

        // Check if this is a total row by looking at the second column
        const secondColumnText = rowData[1]?.content || '';
        const isTotalRow = /^[A-Z] – Total$/.test(secondColumnText) ||
          secondColumnText.startsWith('Subtotal (') ||
          secondColumnText === 'Discount' ||
          secondColumnText === 'Grand Total';

        if (cellText?.includes('₹')) {
          if (isTotalRow) {
            // Hide autoTable's default text rendering
            data.cell.text = [''];
          } else {
            // Use custom font for ₹ values
            data.cell.styles.font = 'NotoSans';
          }
        }
      },

      didDrawPage: function (data) {
        if (data.pageNumber > 1) {
          addHeaderAndLogo();
        }
      },

      didDrawCell: function (data) {
        // Header cell with image
        if (data.row.index === 0 && data.column.index === 0) {
          doc.addImage(
            'img/newHeader.jpg',
            'JPEG',
            data.cell.x,
            data.cell.y,
            152,
            10.5
          );

          doc.setFontSize(10);
          doc.setTextColor(250, 250, 250);
          doc.setFont("VerdanaBold");

          const text = 'Estimated Cost';
          const textX = data.cell.x + 60.5;
          const textY = data.cell.y + 7;
          doc.text(text, textX, textY);
        }

        // Custom drawing for total rows
        if (data.column.index === 2) { // Amount column
          const secondColumnText = data.row.raw[1]?.content || '';
          const raw = data.cell.raw;
          const amountText =
            typeof raw === 'object' && raw !== null && 'content' in raw
              ? raw.content
              : typeof raw === 'string'
                ? raw
                : ''; // Get the original amount text we stored

          // Check if this is a total row and has amount text
          const isTotalRow = /^[A-Z] – Total$/.test(secondColumnText) ||
            secondColumnText.startsWith('Subtotal (') ||
            secondColumnText === 'Discount' ||
            secondColumnText === 'Grand Total';

          if (isTotalRow && amountText && amountText.includes('₹')) {
            const isGrandTotal = secondColumnText === 'Grand Total';
            const isDiscount = secondColumnText === 'Discount';
            drawCustomTotal(doc, amountText, data.cell.x, data.cell.y, data.cell.width, data.cell.height, isGrandTotal, isDiscount);
          }
        }
      }
    });

    // ✅ Get the final Y position and ensure proper spacing
    yPos = doc.lastAutoTable.finalY + 10;

    // ✅ Note section (Verdana except for rupee)
    checkPageSpace(15);
    doc.setFillColor(255, 255, 0);

    const noteText = `Note : ${quotationData.note}`;

    // Set font and size first to get accurate width
    doc.setFontSize(10);
    setSmartFont(noteText, 'bold');
    const noteWidth = doc.getTextWidth(noteText);

    // Background rectangle with proper width (reduced padding from 30 to 6)
    doc.rect(25, yPos - 3, noteWidth + 6, 8, 'F');

    doc.setTextColor(0, 0, 0);
    doc.text(noteText, 25, yPos + 2);
    yPos += 12;

    // ✅ Validity (Verdana)
    checkPageSpace(10);
    doc.setFontSize(10);
    doc.setFont('VerdanaBold', 'normal');
    doc.setTextColor(0, 0, 0);
    doc.text('Validity :', 25, yPos);
    doc.setFont('Verdana', 'normal');
    doc.text(quotationData.validity || 'This quotation is valid for 30 days from the date of issue.', 44, yPos);
    yPos += 6;

    // ✅ Timeline (Verdana)
    doc.setFont('VerdanaBold', 'normal');
    doc.text('Timeline :', 25, yPos);
    doc.setFont('Verdana', 'normal');
    doc.text(quotationData.timeline ||'Estimated project duration: 2-3 weeks from the start date.', 46, yPos);
    yPos += 6;

    // ✅ Payment Terms (Verdana)
    checkPageSpace(10);

    const baseX = 25;
    let baseY = yPos;

    if (quotationData.paymentTermsText) {
      const paymentTerms = quotationData.paymentTermsText
        .split('\n')
        .map(line => line.trim())
        .filter(line => line); // Remove empty lines

      if (paymentTerms.length) {
        const bulletX = baseX;
        baseY += 0;

        doc.setFont('VerdanaBold', 'normal');
        doc.setFontSize(10);
        doc.text("Payment Terms :", bulletX, baseY);

        baseY += 6;

        doc.setFont('Verdana', 'normal');
        doc.setFontSize(10);

        paymentTerms.forEach((term) => {
          const lines = doc.splitTextToSize(`• ${term}`, 160);
          doc.text(lines, bulletX, baseY);
          baseY += lines.length * 6;
        });

        yPos = baseY + 4;
      }
    }

    if (quotationData.featureCategories?.length) {
      quotationData.featureCategories.forEach((cat, index) => {
        const features = cat.featuresText?.split('\n').filter(f => f.trim()) || cat.features || [];
        if (!features.length) return;

        // ✅ Add space only after first section
        if (index > 0) yPos += 6;

        const sectionTitle = (cat.name || `FEATURE ${index + 1}`).toUpperCase();
        let totalSectionHeight = 16;

        features.forEach((feature) => {
          const featureHeight = estimateTextHeight(`• ${feature}`, 160);
          totalSectionHeight += featureHeight + 2;
        });

        const spaceNeeded = totalSectionHeight + 10;

        if (yPos + spaceNeeded > footerStartY) {
          doc.addPage();
          addHeaderAndLogo();
        }

        const x = 25;

        doc.setFont('VerdanaBold', 'normal');
        doc.setFontSize(10);
        doc.text(sectionTitle, x, yPos);

        const textWidth = doc.getTextWidth(sectionTitle);
        doc.setLineWidth(0.5);
        doc.line(x, yPos + 1, x + textWidth, yPos + 1);
        yPos += 8;

        doc.setFont('Verdana', 'normal');
        doc.setFontSize(10);

        features.forEach((feature) => {
          const featureHeight = estimateTextHeight(`• ${feature}`, 160);
          if (featureHeight > 20) {
            checkPageSpace(featureHeight + 5);
          }

          const bulletText = `o ${feature}`;
          const lines = doc.splitTextToSize(bulletText, 160);
          doc.text(lines, 25, yPos);
          yPos += lines.length * 6;
        });

        yPos += 3;
      });
    }

    // ✅ Annual Renewal Section (add this after features section)
    if (quotationData.annualRenewal > 0) {
      yPos += 4;

      const renewalSectionHeight = 20;
      if (yPos + renewalSectionHeight > footerStartY) {
        doc.addPage();
        addHeaderAndLogo();
      }

      const x = 25;

      // Draw label using VerdanaBold
      doc.setFont('VerdanaBold', 'normal');
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.text('Annual Renewal :', x, yPos);

      // Calculate position for amount
      const labelWidth = doc.getTextWidth('Annual Renewal : ');
      const amountStartX = x + labelWidth;

      // Draw ₹ symbol using NotoSans
      doc.setFont('NotoSans', 'normal');
      doc.setFontSize(10);
      doc.text('₹', amountStartX, yPos);

      // Draw number using VerdanaBold
      const rupeeWidth = doc.getTextWidth('₹');
      const numberText = quotationData.annualRenewal.toLocaleString('en-IN', { minimumFractionDigits: 2 });
      doc.setFont('VerdanaBold', 'normal');
      doc.setFontSize(10);
      doc.text(numberText, amountStartX + rupeeWidth, yPos);

      yPos += 8;
    }

    // ✅ Ensure footer is added to the final page if content was added after table
    const currentPage = doc.getCurrentPageInfo().pageNumber;
    const totalPages = doc.getNumberOfPages();

    if (currentPage === totalPages) {
      addFooter();
    }

    doc.save(`quotation-${quotationData.clientName.replace(/[^a-zA-Z0-9]/g, '_')}.pdf`);
  } catch (err) {
    console.error('PDF generation error:', err);
    alert('Something went wrong while generating PDF.');
  } finally {
    setLoading(false);
  }
};
  

  const  handlePreviewPDF = async (quoteId) => {
  await loadQuotation(quoteId);
  
  if (!quotationData.clientName) {
    alert('Please add client name before generating preview');
    return;
  }

  setLoading(true);

    setLoading(true)
  try {
    const doc = new jsPDF();
    const pageHeight = 297;
    const usableHeight = pageHeight - 60; // More conservative footer space
    const footerStartY = 275; // Footer starts at this Y position

    // ✅ Load custom fonts
    doc.addFileToVFS("NotoSans.ttf", notoSansBase64);
    doc.addFont("NotoSans.ttf", "NotoSans", "normal");
    doc.addFont("NotoSans.ttf", "NotoSans", "bold");

    doc.addFileToVFS("Verdana.ttf", verdanaFont);
    doc.addFont("Verdana.ttf", "Verdana", "normal");

    doc.addFileToVFS("VerdanaBold.ttf", verdanaboldFont);
    doc.addFont("VerdanaBold.ttf", "VerdanaBold", "normal");
    doc.addFileToVFS("NotoSansBold.ttf", notoSansboldBase64); // Add your Noto Sans Bold base64 here
    doc.addFont("NotoSansBold.ttf", "NotoSansBold", "normal");
    
    // ✅ Function to add footer to any page
    const addFooter = () => {
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.setFont("Verdana", "normal");

      // Left side - Address and Phone
      doc.text('B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,', 15, 278);
      doc.text('Mahadevapura Post Bangalore – 560048', 15, 283);
      doc.text('Phone: +91 (636) 465 7660, +91 (990) 050 2404', 15, 288);

      // Right side - Email and Website
      doc.text('Email: info@excerptech.com', 150, 278);
      doc.text('Website: www.excerptech.com', 150, 283);

      // ✅ Footer image below footer text
      doc.addImage('/img/newHeader.jpg', 'JPEG', 0, 290, 240, 25);
    };

    let yPos = 0;
    const addHeaderAndLogo = () => {
      doc.addImage('/img/newHeader.jpg', 'JPEG', 0, 0, 210, 8);

      const logoWidth = 42.5;
      const logoHeight = 18;
      const logoY = 15;

      // Left logo
      doc.addImage('img/log1.png', 'PNG', 5, logoY, logoWidth, logoHeight);

      // ✅ Right logo (fixed width issue)
      doc.addImage('img/logo2.png', 'PNG', 210 - 8 - logoWidth, logoY, logoWidth, logoHeight);

      const title = quotationData.title || 'Website design and CRM Quote';
      const maxTitleWidth = 120;
      const titleLines = doc.splitTextToSize(title, maxTitleWidth);
      const titleY = logoY + logoHeight / 2 + 5;

      let titleStartY = titleY;
      if (titleLines.length > 1) {
        titleStartY = titleY - ((titleLines.length - 1) * 3);
      }

      doc.setFont('VerdanaBold', 'normal');
      doc.setFontSize(17);
      doc.setTextColor(0, 0, 0);
      titleLines.forEach((line, index) => {
        doc.text(line, 105, titleStartY + (index * 7), { align: 'center' });
      });

      // ✅ Set yPos globally here based on title
      yPos = titleStartY + (titleLines.length * 10) + 6;

      addFooter();
    };

    // ✅ Add header and footer to first page
    addHeaderAndLogo();

    // ✅ Adjust yPos if title is multi-line
    const title = quotationData.title || 'Website design and CRM Quote';
    const maxTitleWidth = 120;
    const titleLines = doc.splitTextToSize(title, maxTitleWidth);
    if (titleLines.length > 1) {
      yPos += (titleLines.length - 1) * 7;
    }

    // ✅ Client Name (Verdana Bold)
    doc.setFontSize(11);
    doc.setFont('VerdanaBold', 'normal');
    doc.setTextColor(0, 0, 0);
    doc.text(quotationData.clientName, 25, yPos);
    yPos += 4;

    // ✅ Client Address (Verdana Normal)
    doc.setFont('VerdanaBold', 'normal');
    doc.setTextColor(0, 0, 0);
    const addressMaxWidth = 90;
    const lineHeight = 4;

    (quotationData.clientAddress || '').split('\n').forEach(line => {
      const wrappedLines = doc.splitTextToSize(line.trim(), addressMaxWidth);
      wrappedLines.forEach(wrappedLine => {
        doc.text(wrappedLine, 25, yPos);
        yPos += lineHeight;
      });
    });

    yPos += 0;

    // ✅ Services heading (Verdana Bold)
    doc.setFont('VerdanaBold', 'normal');
    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0);
    doc.text('Services', 100, yPos, { align: 'center' });

    // Underline
    const textWidth = doc.getTextWidth('Services');
    const xStart = 100 - textWidth / 2;
    const yLine = yPos + 0.6;
    doc.line(xStart, yLine, xStart + textWidth, yLine);

    yPos += 8;

    // ✅ IMPROVED: Better page space checking function
    const checkPageSpace = (requiredSpace) => {
      // More accurate calculation considering footer space
      if (yPos + requiredSpace > footerStartY) {
        doc.addPage();
        addHeaderAndLogo();
        // ✅ FIXED: Proper yPos calculation for new page considering multi-line titles
        const titleLines = doc.splitTextToSize(quotationData.title || 'Website design and CRM Quote', 120);
        yPos = 58 + (titleLines.length > 1 ? (titleLines.length - 1) * 7 : 0);
        return true;
      }
      return false;
    };

    // ✅ Function to estimate text height more accurately
    const estimateTextHeight = (text, maxWidth, fontSize = 10) => {
      doc.setFontSize(fontSize);
      const lines = doc.splitTextToSize(text, maxWidth);
      return lines.length * 6; // 6 is typical line height
    };

    // ✅ Function to set font based on content (Rupee symbol check)
    const setSmartFont = (text, style = 'normal') => {
      if (typeof text === 'string' && text.includes('₹')) {
        doc.setFont('NotoSans', style);
      } else {
        if (style === 'bold') {
          doc.setFont('VerdanaBold', 'normal');
        } else {
          doc.setFont('Verdana', 'normal');
        }
      }
    };

    let tableData = [];

    // Add the header row
    tableData.push([
      {
        content: 'Estimated Cost',
        colSpan: 3,
        styles: {
          halign: 'center',
          fillColor: [51, 85, 163],
          textColor: [255, 255, 255],
          fontStyle: 'normal',
          fontSize: 15,
          font: 'VerdanaBold',
        }
      }
    ]);

    let serialNumber = 1;
    let subtotal = 0; // Changed from grandTotal to subtotal
    const partTotals = {};

    // Loop through all parts dynamically
    quotationData.parts.forEach((part, partIndex) => {
      const partLetter = String.fromCharCode(65 + partIndex);
      let partTotal = 0;

      // Add part header
      tableData.push([
        {
          content: `Part ${partLetter} – ${part.title}`,
          colSpan: 3,
          styles: {
            halign: 'left',
            fontStyle: 'normal',
            fontSize: 10,
            font: 'VerdanaBold',
          }
        }
      ]);

      // Add items for this part
      part.items.forEach(item => {
        tableData.push([
          {
            content: `${serialNumber++}`,
            styles: { font: 'Verdana' }
          },
          {
            content: item.description,
            styles: { font: 'Verdana' }
          },
          {
            content: `₹ ${item.amount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
            styles: {
              halign: 'right',
              fontSize: 9.5,
              font: 'NotoSans',
              cellPadding: { top: 2, right: 2, bottom: 2, left: 2 }
            }
          }
        ]);
        partTotal += item.amount;
      });

      // Add part total row
      tableData.push([
        {
          content: '',
          styles: { font: 'Verdana' }
        },
        {
          content: `${partLetter} – Total`,
          styles: {
            halign: 'right',
            fontStyle: 'normal',
            font: 'VerdanaBold',
            fillColor: [240, 248, 255]
          }
        },
        {
          content: `₹${partTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
          styles: {
            halign: 'right',
            fontStyle: 'normal',
            font: 'NotoSans',
            fillColor: [240, 248, 255],
          }
        }
      ]);

      partTotals[partLetter] = partTotal;
      subtotal += partTotal;
    });

    // Generate the subtotal label dynamically
    const partLetters = Object.keys(partTotals);
    const subtotalLabel = `Subtotal (${partLetters.join('+')})`;

    // Add subtotal row
    tableData.push([
      {
        content: '',
        styles: { font: 'Verdana' }
      },
      {
        content: subtotalLabel,
        styles: {
          halign: 'right',
          fontStyle: 'normal',
          font: 'VerdanaBold',
        }
      },
      {
        content: `₹ ${subtotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
        styles: {
          halign: 'right',
          fontStyle: 'normal',
          font: 'NotoSans',
        }
      }
    ]);

    // ✅ Add discount row ONLY if discount exists and is greater than 0
    let discountAmount = 0;
    if (quotationData.discount && quotationData.discount > 0) {
      discountAmount = quotationData.discount;
      
      tableData.push([
        {
          content: '',
          styles: { font: 'Verdana' }
        },
        {
          content: 'Discount',
          styles: {
            halign: 'right',
            fontStyle: 'normal',
            font: 'VerdanaBold',
            fillColor: [255, 240, 240] // Light red background for discount
          }
        },
        {
          content: `- ₹ ${discountAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
          styles: {
            halign: 'right',
            fontStyle: 'normal',
            font: 'NotoSans',
            fillColor: [255, 240, 240], // Light red background for discount
            textColor: [200, 0, 0] // Red text for discount
          }
        }
      ]);
    }

    // ✅ Calculate and add grand total (subtotal - discount)
    const grandTotal = subtotal - discountAmount;
    
    tableData.push([
      {
        content: '',
        styles: { font: 'Verdana' }
      },
      {
        content: 'Grand Total',
        styles: {
          halign: 'right',
          fontStyle: 'normal',
          font: 'VerdanaBold',
        }
      },
      {
        content: `₹ ${grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
        styles: {
          halign: 'right',
          fontStyle: 'normal',
          font: 'NotoSansBold',
        }
      }
    ]);

    const drawCustomTotal = (doc, amount, x, y, cellWidth, cellHeight, isGrandTotal = false, isDiscount = false) => {
      const fontSize = isGrandTotal ? 11 : 10.5;
      const rupeeSymbol = isDiscount ? '- ₹' : '₹';
      const numberPart = amount.replace(/^-?\s*₹\s*/, '').trim();

      const cellCenterY = y + cellHeight / 2 + 1.5;
      const rightMargin = 5;

      doc.setFont('NotoSans', 'normal');
      doc.setFontSize(fontSize);
      const rupeeWidth = doc.getTextWidth(rupeeSymbol);

      doc.setFont('VerdanaBold', 'normal');
      doc.setFontSize(fontSize);
      const numberWidth = doc.getTextWidth(numberPart);

      const totalWidth = rupeeWidth + numberWidth + 2;
      const startX = x + cellWidth - totalWidth - rightMargin;

      // 🟦➡️🎀 Only for GRAND TOTAL: Simulate Gradient safely
      if (isGrandTotal) {
        const steps = 45; // fewer steps = bigger slices
        const sliceWidth = cellWidth / steps;

        for (let i = 0; i < steps; i++) {
          const ratio = i / (steps - 1);
          const r = Math.round(0x00 + (0xEC - 0x00) * ratio);
          const g = Math.round(0x47 + (0x6E - 0x47) * ratio);
          const b = Math.round(0xAB + (0xAD - 0xAB) * ratio);

          doc.setFillColor(r, g, b);
          doc.rect(x + (sliceWidth * i), y, sliceWidth, cellHeight, 'F');
        }
      }

      // ₹ Symbol
      doc.setFont('NotoSans', 'normal');
      doc.setFontSize(fontSize);

      if (isGrandTotal) {
        doc.setTextColor(255, 255, 255);
      } else if (isDiscount) {
        doc.setTextColor(200, 0, 0); // Red color for discount
      } else {
        doc.setTextColor(0, 0, 0);
      }

      doc.text(rupeeSymbol, startX, cellCenterY);

      // Number Part
      doc.setFont('VerdanaBold', 'normal');
      doc.setFontSize(fontSize);
      
      if (isGrandTotal) {
        doc.setTextColor(255, 255, 255);
      } else if (isDiscount) {
        doc.setTextColor(200, 0, 0); // Red color for discount
      } else {
        doc.setTextColor(0, 0, 0);
      }
      
      doc.text(numberPart, startX + rupeeWidth + 2, cellCenterY);
    };

    // Replace your existing didParseCell and didDrawCell functions with this:
    autoTable(doc, {
      startY: yPos,
      body: tableData,
      theme: 'grid',
      styles: {
        fontSize: 9.5,
        textColor: [0, 0, 0],
        cellPadding: 2.5,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        fontStyle: 'normal',
        font: 'Verdana',
      },
      headStyles: {
        font: 'VerdanaBold',
        fontStyle: 'normal',
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      bodyStyles: {
        font: 'Verdana',
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      columnStyles: {
        0: { cellWidth: 10, halign: 'center' },
        1: { cellWidth: 110, halign: 'left' },
        2: { cellWidth: 32, halign: 'right' }
      },
      margin: { left: 25, right: 25 },

      didParseCell: (data) => {
        const cellText = data.cell.text?.[0];
        const rowData = data.row.raw;

        // Check if this is a total row by looking at the second column
        const secondColumnText = rowData[1]?.content || '';
        const isTotalRow = /^[A-Z] – Total$/.test(secondColumnText) ||
          secondColumnText.startsWith('Subtotal (') ||
          secondColumnText === 'Discount' ||
          secondColumnText === 'Grand Total';

        if (cellText?.includes('₹')) {
          if (isTotalRow) {
            // Hide autoTable's default text rendering
            data.cell.text = [''];
          } else {
            // Use custom font for ₹ values
            data.cell.styles.font = 'NotoSans';
          }
        }
      },

      didDrawPage: function (data) {
        if (data.pageNumber > 1) {
          addHeaderAndLogo();
        }
      },

      didDrawCell: function (data) {
        // Header cell with image
        if (data.row.index === 0 && data.column.index === 0) {
          doc.addImage(
            'img/newHeader.jpg',
            'JPEG',
            data.cell.x,
            data.cell.y,
            152,
            10.5
          );

          doc.setFontSize(10);
          doc.setTextColor(250, 250, 250);
          doc.setFont("VerdanaBold");

          const text = 'Estimated Cost';
          const textX = data.cell.x + 60.5;
          const textY = data.cell.y + 7;
          doc.text(text, textX, textY);
        }

        // Custom drawing for total rows
        if (data.column.index === 2) { // Amount column
          const secondColumnText = data.row.raw[1]?.content || '';
          const raw = data.cell.raw;
          const amountText =
            typeof raw === 'object' && raw !== null && 'content' in raw
              ? raw.content
              : typeof raw === 'string'
                ? raw
                : ''; // Get the original amount text we stored

          // Check if this is a total row and has amount text
          const isTotalRow = /^[A-Z] – Total$/.test(secondColumnText) ||
            secondColumnText.startsWith('Subtotal (') ||
            secondColumnText === 'Discount' ||
            secondColumnText === 'Grand Total';

          if (isTotalRow && amountText && amountText.includes('₹')) {
            const isGrandTotal = secondColumnText === 'Grand Total';
            const isDiscount = secondColumnText === 'Discount';
            drawCustomTotal(doc, amountText, data.cell.x, data.cell.y, data.cell.width, data.cell.height, isGrandTotal, isDiscount);
          }
        }
      }
    });

    // ✅ Get the final Y position and ensure proper spacing
    yPos = doc.lastAutoTable.finalY + 10;

    // ✅ Note section (Verdana except for rupee)
    checkPageSpace(15);
    doc.setFillColor(255, 255, 0);

    const noteText = `Note : ${quotationData.note}`;

    // Set font and size first to get accurate width
    doc.setFontSize(10);
    setSmartFont(noteText, 'bold');
    const noteWidth = doc.getTextWidth(noteText);

    // Background rectangle with proper width (reduced padding from 30 to 6)
    doc.rect(25, yPos - 3, noteWidth + 6, 8, 'F');

    doc.setTextColor(0, 0, 0);
    doc.text(noteText, 25, yPos + 2);
    yPos += 12;

    // ✅ Validity (Verdana)
    checkPageSpace(10);
    doc.setFontSize(10);
    doc.setFont('VerdanaBold', 'normal');
    doc.setTextColor(0, 0, 0);
    doc.text('Validity :', 25, yPos);
    doc.setFont('Verdana', 'normal');
    doc.text(quotationData.validity || 'This quotation is valid for 30 days from the date of issue.', 44, yPos);
    yPos += 6;

    // ✅ Timeline (Verdana)
    doc.setFont('VerdanaBold', 'normal');
    doc.text('Timeline :', 25, yPos);
    doc.setFont('Verdana', 'normal');
  doc.text(quotationData.timeline ||'Estimated project duration: 2-3 weeks from the start date.', 46, yPos);
    yPos += 6;

    // ✅ Payment Terms (Verdana)
    checkPageSpace(10);

    const baseX = 25;
    let baseY = yPos;

    if (quotationData.paymentTermsText) {
      const paymentTerms = quotationData.paymentTermsText
        .split('\n')
        .map(line => line.trim())
        .filter(line => line); // Remove empty lines

      if (paymentTerms.length) {
        const bulletX = baseX;
        baseY += 0;

        doc.setFont('VerdanaBold', 'normal');
        doc.setFontSize(10);
        doc.text("Payment Terms :", bulletX, baseY);

        baseY += 6;

        doc.setFont('Verdana', 'normal');
        doc.setFontSize(10);

        paymentTerms.forEach((term) => {
          const lines = doc.splitTextToSize(`• ${term}`, 160);
          doc.text(lines, bulletX, baseY);
          baseY += lines.length * 6;
        });

        yPos = baseY + 4;
      }
    }

    if (quotationData.featureCategories?.length) {
      quotationData.featureCategories.forEach((cat, index) => {
        const features = cat.featuresText?.split('\n').filter(f => f.trim()) || cat.features || [];
        if (!features.length) return;

        // ✅ Add space only after first section
        if (index > 0) yPos += 6;

        const sectionTitle = (cat.name || `FEATURE ${index + 1}`).toUpperCase();
        let totalSectionHeight = 16;

        features.forEach((feature) => {
          const featureHeight = estimateTextHeight(`• ${feature}`, 160);
          totalSectionHeight += featureHeight + 2;
        });

        const spaceNeeded = totalSectionHeight + 10;

        if (yPos + spaceNeeded > footerStartY) {
          doc.addPage();
          addHeaderAndLogo();
        }

        const x = 25;

        doc.setFont('VerdanaBold', 'normal');
        doc.setFontSize(10);
        doc.text(sectionTitle, x, yPos);

        const textWidth = doc.getTextWidth(sectionTitle);
        doc.setLineWidth(0.5);
        doc.line(x, yPos + 1, x + textWidth, yPos + 1);
        yPos += 8;

        doc.setFont('Verdana', 'normal');
        doc.setFontSize(10);

        features.forEach((feature) => {
          const featureHeight = estimateTextHeight(`• ${feature}`, 160);
          if (featureHeight > 20) {
            checkPageSpace(featureHeight + 5);
          }

          const bulletText = `o ${feature}`;
          const lines = doc.splitTextToSize(bulletText, 160);
          doc.text(lines, 25, yPos);
          yPos += lines.length * 6;
        });

        yPos += 3;
      });
    }

    // ✅ Annual Renewal Section (add this after features section)
    if (quotationData.annualRenewal > 0) {
      yPos += 4;

      const renewalSectionHeight = 20;
      if (yPos + renewalSectionHeight > footerStartY) {
        doc.addPage();
        addHeaderAndLogo();
      }

      const x = 25;

      // Draw label using VerdanaBold
      doc.setFont('VerdanaBold', 'normal');
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.text('Annual Renewal :', x, yPos);

      // Calculate position for amount
      const labelWidth = doc.getTextWidth('Annual Renewal : ');
      const amountStartX = x + labelWidth;

      // Draw ₹ symbol using NotoSans
      doc.setFont('NotoSans', 'normal');
      doc.setFontSize(10);
      doc.text('₹', amountStartX, yPos);

      // Draw number using VerdanaBold
      const rupeeWidth = doc.getTextWidth('₹');
      const numberText = quotationData.annualRenewal.toLocaleString('en-IN', { minimumFractionDigits: 2 });
      doc.setFont('VerdanaBold', 'normal');
      doc.setFontSize(10);
      doc.text(numberText, amountStartX + rupeeWidth, yPos);

      yPos += 8;
    }

    // ✅ Ensure footer is added to the final page if content was added after table
    const currentPage = doc.getCurrentPageInfo().pageNumber;
    const totalPages = doc.getNumberOfPages();

    if (currentPage === totalPages) {
      addFooter();
    }

  const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, '_blank');
    
    // Clean up the URL after a delay
    setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
  } catch (err) {
    console.error('PDF generation error:', err);
    alert('Something went wrong while generating PDF.');
  } finally {
    setLoading(false);
  }
};
  
  // const  handlePreviewPDF = async (quoteId) => {
  // await loadQuotation(quoteId);
  
  // if (!quotationData.clientName) {
  //   alert('Please add client name before generating preview');
  //   return;
  // }

  // setLoading(true);

  //   setLoading(true);

  //   try {
  //     const doc = new jsPDF();
  //     const pageHeight = 297;
  //     const usableHeight = pageHeight - 60; // More conservative footer space
  //     const footerStartY = 275; // Footer starts at this Y position

  //     // ✅ Load custom fonts
  //     doc.addFileToVFS("NotoSans.ttf", notoSansBase64);
  //     doc.addFont("NotoSans.ttf", "NotoSans", "normal");
  //     doc.addFont("NotoSans.ttf", "NotoSans", "bold");

  //     doc.addFileToVFS("Verdana.ttf", verdanaFont);
  //     doc.addFont("Verdana.ttf", "Verdana", "normal");

  //     doc.addFileToVFS("VerdanaBold.ttf", verdanaboldFont);
  //     doc.addFont("VerdanaBold.ttf", "VerdanaBold", "normal");
  //     doc.addFileToVFS("NotoSansBold.ttf", notoSansboldBase64); // Add your Noto Sans Bold base64 here
  //     doc.addFont("NotoSansBold.ttf", "NotoSansBold", "normal");
  //     // ✅ Function to add footer to any page
  //     const addFooter = () => {
  //       doc.setFontSize(8);
  //       doc.setTextColor(0, 0, 0);
  //       doc.setFont("Verdana", "normal");

  //       // Left side - Address and Phone
  //       doc.text('B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,', 15, 278);
  //       doc.text('Mahadevapura Post Bangalore – 560048', 15, 283);
  //       doc.text('Phone: +91 (636) 465 7660, +91 (990) 050 2404', 15, 288);

  //       // Right side - Email and Website
  //       doc.text('Email: info@excerptech.com', 150, 278);
  //       doc.text('Website: www.excerptech.com', 150, 283);

  //       // ✅ Footer image below footer text
  //       doc.addImage('/img/newHeader.jpg', 'JPEG', 0, 290, 240, 25);
  //     };

  //     // ✅ Function to add header and logo to any page
  //     // const addHeaderAndLogo = () => {
  //     //   // ✅ RESTORED: Top header image
  //     //   doc.addImage('/img/newHeader.jpg', 'JPEG', 0, 0, 210, 8);

  //     //   // Logo positioning - moved down to accommodate header image
  //     //   const logoWidth = 42.5;
  //     //   const logoHeight = 18;
  //     //   const logoY = 13; // Moved down from top due to header image

  //     //   // Left and right logos
  //     //   doc.addImage('img/log1.png', 'PNG', 5, logoY, logoWidth, logoHeight);
  //     //   doc.addImage('img/logo2.png', 'PNG', 210 - 8 - logoWidth, logoY, logoWidth, logoHeight);

  //     //   // ✅ Title with proper text wrapping and positioning
  //     //   const titleY = logoY + logoHeight / 2;
  //     //   doc.setFont('VerdanaBold', 'normal');
  //     //   doc.setFontSize(18);
  //     //   doc.setTextColor(0, 0, 0);

  //     //   const title = quotationData.title || 'Website design and CRM Quote';
  //     //   const maxTitleWidth = 120; // Available width for title (considering logos on both sides)

  //     //   // Split title into lines if too long
  //     //   const titleLines = doc.splitTextToSize(title, maxTitleWidth);

  //     //   // Calculate starting Y position for multi-line titles
  //     //   let titleStartY = titleY;
  //     //   if (titleLines.length > 1) {
  //     //     titleStartY = titleY - ((titleLines.length - 1) * 3); // Adjust for multiple lines
  //     //   }

  //     //   // Draw each line of the title
  //     //   titleLines.forEach((line, index) => {
  //     //     doc.text(line, 105, titleStartY + (index * 7), { align: 'center' });
  //     //   });

  //     //   // ✅ Add footer to every page when header is added
  //     //   addFooter();
  //     // };

  //     let yPos = 0;
  //     const addHeaderAndLogo = () => {
  //       doc.addImage('/img/newHeader.jpg', 'JPEG', 0, 0, 210, 8);

  //       const logoWidth = 42.5;
  //       const logoHeight = 18;
  //       const logoY = 15;

  //       // Left logo
  //       doc.addImage('img/log1.png', 'PNG', 5, logoY, logoWidth, logoHeight);

  //       // ✅ Right logo (fixed width issue)
  //       doc.addImage('img/logo2.png', 'PNG', 210 - 8 - logoWidth, logoY, logoWidth, logoHeight);

  //       const title = quotationData.title || 'Website design and CRM Quote';
  //       const maxTitleWidth = 120;
  //       const titleLines = doc.splitTextToSize(title, maxTitleWidth);
  //       const titleY = logoY + logoHeight / 2 + 5;

  //       let titleStartY = titleY;
  //       if (titleLines.length > 1) {
  //         titleStartY = titleY - ((titleLines.length - 1) * 3);
  //       }

  //       doc.setFont('VerdanaBold', 'normal');
  //       doc.setFontSize(17);
  //       doc.setTextColor(0, 0, 0);
  //       titleLines.forEach((line, index) => {
  //         doc.text(line, 105, titleStartY + (index * 7), { align: 'center' });
  //       });

  //       // ✅ Set yPos globally here based on title
  //       yPos = titleStartY + (titleLines.length * 10) + 6;

  //       addFooter();
  //     };


  //     // ✅ Add header and footer to first page
  //     addHeaderAndLogo();

  //     //let yPos = 18 + 18 + 2; // logoY + logoHeight + spacing

  //     // ✅ Adjust yPos if title is multi-line
  //     const title = quotationData.title || 'Website design and CRM Quote';
  //     const maxTitleWidth = 120;
  //     const titleLines = doc.splitTextToSize(title, maxTitleWidth);
  //     if (titleLines.length > 1) {
  //       yPos += (titleLines.length - 1) * 7;
  //     }

  //     // ✅ Client Name (Verdana Bold)
  //     doc.setFontSize(11);
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setTextColor(0, 0, 0);
  //     doc.text(quotationData.clientName, 25, yPos);
  //     yPos += 4;

  //     // ✅ Client Address (Verdana Normal)
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setTextColor(0, 0, 0);
  //     const addressMaxWidth = 90;
  //     const lineHeight = 4;

  //     (quotationData.clientAddress || '').split('\n').forEach(line => {
  //       const wrappedLines = doc.splitTextToSize(line.trim(), addressMaxWidth);
  //       wrappedLines.forEach(wrappedLine => {
  //         doc.text(wrappedLine, 25, yPos);
  //         yPos += lineHeight;
  //       });
  //     });

  //     yPos += 0;

  //     // ✅ Services heading (Verdana Bold)
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setFontSize(11);
  //     doc.setTextColor(0, 0, 0);
  //     doc.text('Services', 100, yPos, { align: 'center' });

  //     // Underline
  //     const textWidth = doc.getTextWidth('Services');
  //     const xStart = 100 - textWidth / 2;
  //     const yLine = yPos + 0.6;
  //     doc.line(xStart, yLine, xStart + textWidth, yLine);

  //     yPos += 8;

  //     // ✅ IMPROVED: Better page space checking function
  //     const checkPageSpace = (requiredSpace) => {
  //       // More accurate calculation considering footer space
  //       if (yPos + requiredSpace > footerStartY) {
  //         doc.addPage();
  //         addHeaderAndLogo();
  //         // ✅ FIXED: Proper yPos calculation for new page considering multi-line titles
  //         const titleLines = doc.splitTextToSize(quotationData.title || 'Website design and CRM Quote', 120);
  //         yPos = 58 + (titleLines.length > 1 ? (titleLines.length - 1) * 7 : 0);
  //         return true;
  //       }
  //       return false;
  //     };

  //     // ✅ Function to estimate text height more accurately
  //     const estimateTextHeight = (text, maxWidth, fontSize = 10) => {
  //       doc.setFontSize(fontSize);
  //       const lines = doc.splitTextToSize(text, maxWidth);
  //       return lines.length * 6; // 6 is typical line height
  //     };

  //     // ✅ Function to set font based on content (Rupee symbol check)
  //     const setSmartFont = (text, style = 'normal') => {
  //       if (typeof text === 'string' && text.includes('₹')) {
  //         doc.setFont('NotoSans', style);
  //       } else {
  //         if (style === 'bold') {
  //           doc.setFont('VerdanaBold', 'normal');
  //         } else {
  //           doc.setFont('Verdana', 'normal');
  //         }
  //       }
  //     };

  //     let tableData = [];

  //     // Add the header row
  //     tableData.push([
  //       {
  //         content: 'Estimated Cost',
  //         colSpan: 3,
  //         styles: {
  //           halign: 'center',
  //           fillColor: [51, 85, 163],
  //           textColor: [255, 255, 255],
  //           fontStyle: 'normal',
  //           fontSize: 15,
  //           font: 'VerdanaBold',
  //         }
  //       }
  //     ]);

  //     let serialNumber = 1;
  //     let grandTotal = 0;
  //     const partTotals = {};

  //     // Loop through all parts dynamically
  //     quotationData.parts.forEach((part, partIndex) => {
  //       const partLetter = String.fromCharCode(65 + partIndex);
  //       let partTotal = 0;

  //       // Add part header
  //       tableData.push([
  //         {
  //           content: `Part ${partLetter} – ${part.title}`,
  //           colSpan: 3,
  //           styles: {
  //             halign: 'left',
  //             fontStyle: 'normal',
  //             fontSize: 10,
  //             font: 'VerdanaBold',
  //           }
  //         }
  //       ]);

  //       // Add items for this part
  //       part.items.forEach(item => {
  //         tableData.push([
  //           {
  //             content: `${serialNumber++}`,
  //             styles: { font: 'Verdana' }
  //           },
  //           {
  //             content: item.description,
  //             styles: { font: 'Verdana' }
  //           },
  //           {
  //             content: `₹ ${item.amount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
  //             styles: {
  //               halign: 'right',
  //               fontSize: 9.5,
  //               font: 'NotoSans',
  //               cellPadding: { top: 2, right: 2, bottom: 2, left: 2 }
  //             }
  //           }
  //         ]);
  //         partTotal += item.amount;
  //       });

  //       // Add part total row
  //       tableData.push([
  //         {
  //           content: '',
  //           styles: { font: 'Verdana' }
  //         },
  //         {
  //           content: `${partLetter} – Total`,
  //           styles: {
  //             halign: 'right',
  //             fontStyle: 'normal',
  //             font: 'VerdanaBold',
  //             fillColor: [240, 248, 255]
  //           }
  //         },
  //         {
  //           content: `₹${partTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
  //           styles: {
  //             halign: 'right',
  //             fontStyle: 'normal',
  //             font: 'NotoSans',
  //             fillColor: [240, 248, 255],
  //           }
  //         }
  //       ]);

  //       partTotals[partLetter] = partTotal;
  //       grandTotal += partTotal;
  //     });

  //     // Generate the total label dynamically
  //     const partLetters = Object.keys(partTotals);
  //     const totalLabel = `Total (${partLetters.join('+')})`;

  //     // Add grand total row
  //     tableData.push([
  //       {
  //         content: '',
  //         styles: { font: 'Verdana' }
  //       },
  //       {
  //         content: totalLabel,
  //         styles: {
  //           halign: 'right',
  //           fontStyle: 'normal',
  //           font: 'VerdanaBold',
  //         }
  //       },
  //       {
  //         content: `₹ ${grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
  //         styles: {
  //           halign: 'right',
  //           fontStyle: 'normal',
  //           font: 'NotoSansBold',
  //         }
  //       }
  //     ]);

  //     // Add this function before your autoTable call
  //     // const drawCustomTotal = (doc, amount, x, y, cellWidth, cellHeight, isGrandTotal = false) => {
  //     //   const fontSize = isGrandTotal ? 11 : 10.5;
  //     //   const rupeeSymbol = '₹';
  //     //   const numberPart = amount.replace('₹', '').trim();

  //     //   // Calculate positioning for right alignment
  //     //   const cellCenterY = y + cellHeight / 2 + 1.5;
  //     //   const rightMargin = 5; // Space from right edge

  //     //   // Measure text widths
  //     //   doc.setFont('NotoSans', 'normal');
  //     //   doc.setFontSize(fontSize);
  //     //   const rupeeWidth = doc.getTextWidth(rupeeSymbol);

  //     //   doc.setFont('VerdanaBold', 'normal');
  //     //   doc.setFontSize(fontSize);
  //     //   const numberWidth = doc.getTextWidth(numberPart);

  //     //   // Calculate positions for right alignment
  //     //   const totalWidth = rupeeWidth + numberWidth + 2; // +2 for small space between ₹ and number
  //     //   const startX = x + cellWidth - totalWidth - rightMargin;

  //     //   // Draw ₹ symbol with NotoSans
  //     //   doc.setFont('NotoSans', 'normal');
  //     //   doc.setFontSize(fontSize);
  //     //   doc.setTextColor(0, 0, 0);
  //     //   doc.text(rupeeSymbol, startX, cellCenterY);

  //     //   // Draw number with VerdanaBold
  //     //   doc.setFont('VerdanaBold', 'normal');
  //     //   doc.setFontSize(fontSize);
  //     //   doc.setTextColor(0, 0, 0);
  //     //   doc.text(numberPart, startX + rupeeWidth + 2, cellCenterY);
  //     // };


  //     // const drawCustomTotal = (doc, amount, x, y, cellWidth, cellHeight, isGrandTotal = false) => {
  //     //   const fontSize = isGrandTotal ? 11 : 10.5;
  //     //   const rupeeSymbol = '₹';
  //     //   const numberPart = amount.replace('₹', '').trim();

  //     //   // Calculate positioning for right alignment
  //     //   const cellCenterY = y + cellHeight / 2 + 1.5;
  //     //   const rightMargin = 5;

  //     //   // Measure text widths
  //     //   doc.setFont('NotoSans', 'normal');
  //     //   doc.setFontSize(fontSize);
  //     //   const rupeeWidth = doc.getTextWidth(rupeeSymbol);

  //     //   doc.setFont('VerdanaBold', 'normal');
  //     //   doc.setFontSize(fontSize);
  //     //   const numberWidth = doc.getTextWidth(numberPart);

  //     //   const totalWidth = rupeeWidth + numberWidth + 2;
  //     //   const startX = x + cellWidth - totalWidth - rightMargin;

  //     //   // === ✅ Only for GRAND TOTAL: Draw Blue → Pink gradient ===
  //     //   if (isGrandTotal) {
  //     //     const steps = 30; // More steps = smoother gradient
  //     //     for (let i = 0; i < steps; i++) {
  //     //       const ratio = i / (steps - 1);
  //     //       const r = Math.round(110 * (1 - ratio) + 247 * ratio); // R: blue to pink
  //     //       const g = Math.round(168 * (1 - ratio) + 138 * ratio); // G
  //     //       const b = Math.round(254 * (1 - ratio) + 203 * ratio); // B

  //     //       doc.setFillColor(r, g, b);
  //     //       doc.rect(x + (cellWidth * ratio), y, cellWidth / steps + 0.5, cellHeight, 'F');
  //     //     }
  //     //   }

  //     //   // === ₹ Symbol ===
  //     //   doc.setFont('NotoSans', 'normal');
  //     //   doc.setFontSize(fontSize);
  //     //   doc.setTextColor(0, 0, 0);
  //     //   doc.text(rupeeSymbol, startX, cellCenterY);

  //     //   // === Number Part ===
  //     //   doc.setFont('VerdanaBold', 'normal');
  //     //   doc.setFontSize(fontSize);
  //     //   doc.setTextColor(0, 0, 0);
  //     //   doc.text(numberPart, startX + rupeeWidth + 2, cellCenterY);
  //     // };

  //     const drawCustomTotal = (doc, amount, x, y, cellWidth, cellHeight, isGrandTotal = false) => {
  //       const fontSize = isGrandTotal ? 11 : 10.5;
  //       const rupeeSymbol = '₹';
  //       const numberPart = amount.replace('₹', '').trim();

  //       const cellCenterY = y + cellHeight / 2 + 1.5;
  //       const rightMargin = 5;

  //       doc.setFont('NotoSans', 'normal');
  //       doc.setFontSize(fontSize);
  //       const rupeeWidth = doc.getTextWidth(rupeeSymbol);

  //       doc.setFont('VerdanaBold', 'normal');
  //       doc.setFontSize(fontSize);
  //       const numberWidth = doc.getTextWidth(numberPart);

  //       const totalWidth = rupeeWidth + numberWidth + 2;
  //       const startX = x + cellWidth - totalWidth - rightMargin;

  //       // 🟦➡️🎀 Only for GRAND TOTAL: Simulate Gradient safely
  //       if (isGrandTotal) {
  //         const steps = 45; // fewer steps = bigger slices
  //         const sliceWidth = cellWidth / steps;

  //         for (let i = 0; i < steps; i++) {
  //           const ratio = i / (steps - 1);
  //           const r = Math.round(0x00 + (0xEC - 0x00) * ratio);
  //           const g = Math.round(0x47 + (0x6E - 0x47) * ratio);
  //           const b = Math.round(0xAB + (0xAD - 0xAB) * ratio);

  //           doc.setFillColor(r, g, b);
  //           doc.rect(x + (sliceWidth * i), y, sliceWidth, cellHeight, 'F');
  //         }
  //       }

  //       // ₹ Symbol
  //       doc.setFont('NotoSans', 'normal');
  //       doc.setFontSize(fontSize);

  //       if(isGrandTotal){
  //         doc.setTextColor(255,255,255)
  //       }else{
  //       doc.setTextColor(0, 0, 0)
  //       };

  //       doc.text(rupeeSymbol, startX, cellCenterY);

  //       // Number Part
  //       doc.setFont('VerdanaBold', 'normal');
  //       doc.setFontSize(fontSize);
  //       if(isGrandTotal){doc.setTextColor(255,255,255)}else{
  //       doc.setTextColor(0, 0, 0)};
  //       doc.text(numberPart, startX + rupeeWidth + 2, cellCenterY);
  //     };





  //     // Replace your existing didParseCell and didDrawCell functions with this:
  //     autoTable(doc, {
  //       startY: yPos,
  //       body: tableData,
  //       theme: 'grid',
  //       styles: {
  //         fontSize: 9.5,
  //         textColor: [0, 0, 0],
  //         cellPadding: 2.5,
  //         lineColor: [0, 0, 0],
  //         lineWidth: 0.1,
  //         fontStyle: 'normal',
  //         font: 'Verdana',
  //       },
  //       headStyles: {
  //         font: 'VerdanaBold',
  //         fontStyle: 'normal',
  //         lineColor: [0, 0, 0],
  //         lineWidth: 0.1,
  //       },
  //       bodyStyles: {
  //         font: 'Verdana',
  //         lineColor: [0, 0, 0],
  //         lineWidth: 0.1,
  //       },
  //       columnStyles: {
  //         0: { cellWidth: 10, halign: 'center' },
  //         1: { cellWidth: 110, halign: 'left' },
  //         2: { cellWidth: 32, halign: 'right' }
  //       },
  //       margin: { left: 25, right: 25 },

  //       didParseCell: (data) => {
  //         const cellText = data.cell.text?.[0];
  //         const rowData = data.row.raw;

  //         // Check if this is a total row by looking at the second column
  //         const secondColumnText = rowData[1]?.content || '';
  //         const isTotalRow = /^[A-Z] – Total$/.test(secondColumnText) ||
  //           secondColumnText.startsWith('Total (') ||
  //           secondColumnText === 'Total';


  //         // if (isTotalRow && data.column.index === 2) {
  //         //   data.cell.raw = cellText;

  //         //   data.cell.text = [''];
  //         //   data.cell.styles.fillColor = secondColumnText.startsWith('Total ') ? [255, 255, 255] : [230, 240, 255];

  //         // }

  //         // if (isTotalRow && data.column.index === 2) {
  //         //   const secondColumnText = data.row.raw[1]?.content || '';
  //         //   const raw = data.cell.raw;
  //         //   const amountText =
  //         //     typeof raw === 'object' && raw !== null && 'content' in raw
  //         //       ? raw.content
  //         //       : typeof raw === 'string'
  //         //         ? raw
  //         //         : '';
  //         //   console.log(amountText)
  //         //   const isTotalRow = /^[A-Z] – Total$/.test(secondColumnText) ||
  //         //     secondColumnText.startsWith('Total (') ||
  //         //     secondColumnText === 'Total';

  //         //   const isGrandTotal = secondColumnText.startsWith('Total (') || secondColumnText === 'Total';

  //         //   if (isTotalRow && amountText && amountText.includes('₹')) {
  //         //     drawCustomTotal(doc, amountText, data.cell.x, data.cell.y, data.cell.width, data.cell.height, isGrandTotal);
  //         //   }
  //         // }


  //         // Regular items with ₹ symbols (not total rows)
  //         // if (cellText?.includes('₹') && !isTotalRow) {
  //         //   data.cell.styles.font = 'NotoSans';
  //         // }
  //         if (cellText?.includes('₹')) {
  //           if (isTotalRow) {
  //             // Hide autoTable’s default text rendering
  //             data.cell.text = [''];
  //           } else {
  //             // Use custom font for ₹ values
  //             data.cell.styles.font = 'NotoSans';
  //           }
  //         }

  //       },

  //       didDrawPage: function (data) {
  //         if (data.pageNumber > 1) {
  //           addHeaderAndLogo();
  //         }
  //       },

  //       didDrawCell: function (data) {
  //         // Header cell with image
  //         if (data.row.index === 0 && data.column.index === 0) {
  //           doc.addImage(
  //             'img/newHeader.jpg',
  //             'JPEG',
  //             data.cell.x,
  //             data.cell.y,
  //             152,
  //             10.5
  //           );

  //           doc.setFontSize(10);
  //           doc.setTextColor(250, 250, 250);
  //           doc.setFont("VerdanaBold");

  //           const text = 'Estimated Cost';
  //           const textX = data.cell.x + 60.5;
  //           const textY = data.cell.y + 7;
  //           doc.text(text, textX, textY);
  //         }

  //         // Custom drawing for total rows
  //         if (data.column.index === 2) { // Amount column
  //           const secondColumnText = data.row.raw[1]?.content || '';
  //           const raw = data.cell.raw;
  //           const amountText =
  //             typeof raw === 'object' && raw !== null && 'content' in raw
  //               ? raw.content
  //               : typeof raw === 'string'
  //                 ? raw
  //                 : ''; // Get the original amount text we stored

  //           // Check if this is a total row and has amount text
  //           const isTotalRow = /^[A-Z] – Total$/.test(secondColumnText) ||
  //             secondColumnText.startsWith('Total (') ||
  //             secondColumnText === 'Total';

  //           if (isTotalRow && amountText && amountText.includes('₹')) {
  //             const isGrandTotal = secondColumnText.startsWith('Total (') || secondColumnText === 'Total';
  //             drawCustomTotal(doc, amountText, data.cell.x, data.cell.y, data.cell.width, data.cell.height, isGrandTotal);
  //           }
  //         }
  //       }
  //     });

  //     // ✅ Get the final Y position and ensure proper spacing
  //     yPos = doc.lastAutoTable.finalY + 10;

  //     // ✅ Note section (Verdana except for rupee)
  //     // ✅ Note section (Verdana except for rupee)
  //     checkPageSpace(15);
  //     doc.setFillColor(255, 255, 0);

  //     const noteText = `Note : ${quotationData.note}`;

  //     // Set font and size first to get accurate width
  //     doc.setFontSize(10);
  //     setSmartFont(noteText, 'bold');
  //     const noteWidth = doc.getTextWidth(noteText);

  //     // Background rectangle with proper width (reduced padding from 30 to 6)
  //     doc.rect(25, yPos - 3, noteWidth + 6, 8, 'F');

  //     doc.setTextColor(0, 0, 0);
  //     doc.text(noteText, 25, yPos + 2);
  //     yPos += 12;

  //     // ✅ Validity (Verdana)
  //     checkPageSpace(10);
  //     doc.setFontSize(10);
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.setTextColor(0, 0, 0);
  //     doc.text('Validity :', 25, yPos);
  //     doc.setFont('Verdana', 'normal');
  //     doc.text(quotationData.validity || 'This quotation is valid for 30 days from the date of issue.', 44, yPos);
  //     yPos += 6;

  //     // ✅ Timeline (Verdana)
  //     doc.setFont('VerdanaBold', 'normal');
  //     doc.text('Timeline :', 25, yPos);
  //     doc.setFont('Verdana', 'normal');
  //     doc.text('Estimated project duration: 2-3 weeks from the start date.', 46, yPos);
  //     yPos += 6;

  //     // ✅ Payment Terms (Verdana)

  //     // ✅ Add a space after the colon
  //     checkPageSpace(10);

  //     const baseX = 25;
  //     let baseY = yPos;
  //     // Print each bullet on a new line with bullet character

  //     if (quotationData.paymentTermsText) {
  //       const paymentTerms = quotationData.paymentTermsText
  //         .split('\n')
  //         .map(line => line.trim())
  //         .filter(line => line); // Remove empty lines

  //       if (paymentTerms.length) {
  //         const bulletX = baseX;
  //         baseY += 0;

  //         doc.setFont('VerdanaBold', 'normal');
  //         doc.setFontSize(10);
  //         doc.text("Payment Terms :", bulletX, baseY);
  //         const titleWidth = doc.getTextWidth("PAYMENT TERMS :");

  //         baseY += 6;

  //         doc.setFont('Verdana', 'normal');
  //         doc.setFontSize(10);

  //         paymentTerms.forEach((term) => {
  //           const lines = doc.splitTextToSize(`• ${term}`, 160);
  //           doc.text(lines, bulletX, baseY);
  //           baseY += lines.length * 6;
  //         });

  //         yPos = baseY + 4;
  //       }
  //     }




  //     // Update yPos after all lines
  //     // yPos = baseY + 4;


  //     if (quotationData.featureCategories?.length) {
  //       quotationData.featureCategories.forEach((cat, index) => {
  //         const features = cat.featuresText?.split('\n').filter(f => f.trim()) || cat.features || [];
  //         if (!features.length) return;

  //         // ✅ Add space only after first section
  //         if (index > 0) yPos += 6;


  //         const sectionTitle = (cat.name || `FEATURE ${index + 1}`).toUpperCase();
  //         let totalSectionHeight = 16;

  //         features.forEach((feature) => {
  //           const featureHeight = estimateTextHeight(`• ${feature}`, 160);
  //           totalSectionHeight += featureHeight + 2;
  //         });

  //         const spaceNeeded = totalSectionHeight + 10;

  //         if (yPos + spaceNeeded > footerStartY) {
  //           doc.addPage();
  //           addHeaderAndLogo();

  //         }

  //         const x = 25;

  //         doc.setFont('VerdanaBold', 'normal');
  //         doc.setFontSize(10);
  //         doc.text(sectionTitle, x, yPos);

  //         const textWidth = doc.getTextWidth(sectionTitle);
  //         doc.setLineWidth(0.5);
  //         doc.line(x, yPos + 1, x + textWidth, yPos + 1);
  //         yPos += 8;

  //         doc.setFont('Verdana', 'normal');
  //         doc.setFontSize(10);

  //         features.forEach((feature) => {
  //           const featureHeight = estimateTextHeight(`• ${feature}`, 160);
  //           if (featureHeight > 20) {
  //             checkPageSpace(featureHeight + 5);
  //           }

  //           const bulletText = `o ${feature}`;
  //           const lines = doc.splitTextToSize(bulletText, 160);
  //           doc.text(lines, 25, yPos);
  //           yPos += lines.length * 6;
  //         });

  //         yPos += 3;
  //       });
  //     }
  //     // ✅ Annual Renewal Section (add this after features section)
  //     // ✅ Annual Renewal Section (add this after features section)
  //     if (quotationData.annualRenewal > 0) {
  //       yPos += 4;

  //       const renewalSectionHeight = 20;
  //       if (yPos + renewalSectionHeight > footerStartY) {
  //         doc.addPage();
  //         addHeaderAndLogo();
  //       }

  //       const x = 25;

  //       // Draw label using VerdanaBold
  //       doc.setFont('VerdanaBold', 'normal');
  //       doc.setFontSize(10);
  //       doc.setTextColor(0, 0, 0);
  //       doc.text('Annual Renewal :', x, yPos);

  //       // Calculate position for amount
  //       const labelWidth = doc.getTextWidth('Annual Renewal : ');
  //       const amountStartX = x + labelWidth;

  //       // Draw ₹ symbol using NotoSans
  //       doc.setFont('NotoSans', 'normal');
  //       doc.setFontSize(10);
  //       doc.text('₹', amountStartX, yPos);

  //       // Draw number using VerdanaBold
  //       const rupeeWidth = doc.getTextWidth('₹');
  //       const numberText = quotationData.annualRenewal.toLocaleString('en-IN', { minimumFractionDigits: 2 });
  //       doc.setFont('VerdanaBold', 'normal');
  //       doc.setFontSize(10);
  //       doc.text(numberText, amountStartX + rupeeWidth, yPos); // +1 for small space

  //       yPos += 8;
  //     }


  //     // ✅ Ensure footer is added to the final page if content was added after table
  //     const currentPage = doc.getCurrentPageInfo().pageNumber;
  //     const totalPages = doc.getNumberOfPages();

  //     if (currentPage === totalPages) {
  //       addFooter();
  //     }

  //   const pdfBlob = doc.output('blob');
  //   const pdfUrl = URL.createObjectURL(pdfBlob);
  //   window.open(pdfUrl, '_blank');
    
  //   // Clean up the URL after a delay
  //   setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
    
  //   } catch (err) {
  //     console.error('PDF generation error:', err);
  //     alert('Something went wrong while generating PDF.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const updateItem = (partId, itemId, field, value) => {
    setQuotationData(prev => ({
      ...prev,
      parts: prev.parts.map(part =>
        part.id === partId
          ? {
            ...part,
            items: part.items.map(item =>
              item.id === itemId
                ? { ...item, [field]: field === 'amount' ? parseFloat(value) || 0 : value }
                : item
            )
          }
          : part
      )
    }));
  };

  // Feature category management functions
  const addFeatureCategory = () => {
    if (!newCategoryName.trim()) return;

    const newCategory = {
      id: Date.now(),
      name: newCategoryName,
      color: `#${Math.floor(Math.random() * 16777215).toString(16)}33`, // Random light color
      features: []
    };

    setQuotationData(prev => ({
      ...prev,
      featureCategories: [...prev.featureCategories, newCategory]
    }));

    setNewCategoryName('');
    setOpenFeatureCategoryDialog(false);
  };

  const deleteFeatureCategory = (categoryId) => {
    setQuotationData(prev => ({
      ...prev,
      featureCategories: prev.featureCategories.filter(cat => cat.id !== categoryId)
    }));
  };

  const updateFeatureCategoryName = (categoryId, name) => {
    setQuotationData(prev => ({
      ...prev,
      featureCategories: prev.featureCategories.map(cat =>
        cat.id === categoryId ? { ...cat, name } : cat
      )
    }));
  };

  // Feature management functions
  const addFeature = (categoryId) => {
    setQuotationData(prev => ({
      ...prev,
      featureCategories: prev.featureCategories.map(cat =>
        cat.id === categoryId
          ? { ...cat, features: [...cat.features, ''] }
          : cat
      )
    }));
  };
  const updateFeatures = (categoryId, value) => {
    setQuotationData(prev => ({
      ...prev,
      featureCategories: prev.featureCategories.map(cat =>
        cat.id === categoryId
          ? { ...cat, featuresText: value } // Store as string, not array
          : cat
      )
    }));
  };


  const deleteFeature = (categoryId, featureIndex) => {
    setQuotationData(prev => ({
      ...prev,
      featureCategories: prev.featureCategories.map(cat =>
        cat.id === categoryId
          ? {
            ...cat,
            features: cat.features.filter((_, index) => index !== featureIndex)
          }
          : cat
      )
    }));
  };

  // Calculation functions
  const calculatePartTotal = (part) => {
    return part.items.reduce((sum, item) => sum + item.amount, 0);
  };

const calculateGrandTotal = () => {
  const subtotal = quotationData.parts.reduce((sum, part) => sum + calculatePartTotal(part), 0);
  const discount = parseFloat(quotationData.discount) || 0;
  return Math.max(0, subtotal - discount); // Ensure total doesn't go below 0
};

// Add this function to update discount
const updateDiscount = (value) => {
  setQuotationData(prev => ({
    ...prev,
    discount: value
  }));
};

  // Save quotation
  // Replace your handleSave function with this:
  const handleSave = async () => {
    setLoading(true);
    try {
      // Convert featuresText back to features array before saving
      const quotationDataForSave = {
        ...quotationData,
        featureCategories: quotationData.featureCategories.map(category => ({
          ...category,
          features: category.featuresText
            ? category.featuresText.split('\n').filter(feature => feature.trim() !== '')
            : (category.features || [])
        }))
      };

      const method = selectedQuotation ? 'PUT' : 'POST';
      const url = selectedQuotation
        ? `/api/quotations/${selectedQuotation}`
        : '/api/quotations';

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(quotationDataForSave), // Use the converted data
      });

      if (response.ok) {
        const result = await response.json();
        alert('Quotation saved successfully!');
        setSelectedQuotation(result.id);
         setSelectedId(result.id);
        await handlePreviewPDF(result.id);
              handleCloseForm()
        loadQuotations();
  
      } else {
        throw new Error('Failed to save quotation');
      }
    } catch (error) {
      console.error('Error saving quotation:', error);
      alert('Error saving quotation. Please try again.');
    } finally {
      setLoading(false);
    }
  };


  // Generate PDF


  // Create new quotation
  const createNewQuotation = () => {
    setQuotationData({
      title: 'New Quotation',
      clientName: '',
      clientAddress: '',
      parts: [],
      featureCategories: [],
      note: '18% GST will be applicable on all orders.',
      validity: '30 days from the date of issue',
      timeline: '5 – 8 weeks from the start date',
      annualRenewal: 0
    });
    setSelectedQuotation(null);
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ py: 4 }}>

        <Paper elevation={3} sx={{ mb: 4, background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)' }}>
          <Box sx={{ p: 4, color: 'white' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{
                  width: 64,
                  height: 64,
                  bgcolor: 'white',
                  borderRadius: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mr: 3
                }}>
                  <DescriptionIcon sx={{ fontSize: 32, color: '#1976d2' }} />
                </Box>

              </Box>
              <Box>
                <Button
                  variant="contained"
                  sx={{ bgcolor: 'white', color: '#1976d2', mr: 2 }}
         onClick={handleNewQuotation}
                >
                  New Quotation
                </Button>
              </Box>
            </Box>
          </Box>
        </Paper>


        {/* {quotationTableData.length > 0 && (
          <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h6">Saved Quotations</Typography>
             
            </Box>

            <Box sx={{ overflow: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ backgroundColor: '#f5f5f5' }}>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>
                      Title
                    </th>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>
                      Client Name
                    </th>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>
                      Total Amount
                    </th>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>
                      Created Date
                    </th>
                    <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #ddd' }}>
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {quotationTableData.map((quote) => (
                    <tr key={quote.id} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '12px' }}>{quote.title}</td>
                      <td style={{ padding: '12px' }}>{quote.clientName}</td>
                      <td style={{ padding: '12px' }}>₹{quote.total.toFixed(2)}</td>
                      <td style={{ padding: '12px' }}>{quote.createdAt}</td>
                      <td style={{ padding: '12px', textAlign: 'center' }}>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => handleEditQuotation(quote.id)}
                          sx={{ mr: 1 }}
                        >
                          Edit
                        </Button>
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => {
                            setSelectedId(quote.id);
                            setAutoGeneratePDF(true);
                            loadQuotation(quote.id);
                          }}
                        >
                          PDF
                        </Button>
                        <div style={{ display: 'flex', gap: '8px' }}>
 
  
  <Button
    variant="outlined"
    size="small"
    onClick={() => {
      setSelectedId(quote.id);
      handlePreviewPDF(quote.id);
    }}
  >
    Preview
  </Button>
</div>

                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          </Paper>
        )} */}



{quotationTableData.length > 0 && (
  <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
      <Typography variant="h6">Saved Quotations</Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <TextField
          placeholder="Search quotations..."
          value={searchTerm}
          onChange={handleSearch}
          size="small"
          sx={{ minWidth: 250 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
            endAdornment: searchTerm && (
              <InputAdornment position="end">
                <IconButton onClick={clearSearch} size="small">
                  <Clear />
                </IconButton>
              </InputAdornment>
            )
          }}
        />
        {searchTerm && (
          <Chip 
            label={`${filteredData.length} result${filteredData.length !== 1 ? 's' : ''}`}
            size="small"
            color="primary"
            variant="outlined"
          />
        )}
      </Box>
    </Box>
    
    <Box sx={{ overflow: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ backgroundColor: '#f5f5f5' }}>
            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>
              Title
            </th>
            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>
              Client Name
            </th>
            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>
              Total Amount
            </th>
            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>
              Created Date
            </th>
            <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #ddd' }}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.length > 0 ? (
            paginatedData.map((quote) => (
              <tr key={quote.id} style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '12px' }}>{quote.title}</td>
                <td style={{ padding: '12px' }}>{quote.clientName}</td>
                <td style={{ padding: '12px' }}>₹{quote.total.toFixed(2)}</td>
                <td style={{ padding: '12px' }}>{quote.createdAt}</td>
                <td style={{ padding: '12px', textAlign: 'center' }}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => handleEditQuotation(quote.id)}
                    sx={{ mr: 1 }}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => {
                      setSelectedId(quote.id);
                      setAutoGeneratePDF(true);
                      loadQuotation(quote.id);
                    }}
                    sx={{ mr: 1 }}
                  >
                    PDF
                  </Button>
                  {/* <Button
                    variant="outlined"
                    size="small"
                    onClick={() => {
                      setSelectedId(quote.id);
                      handlePreviewPDF(quote.id);
                    }}
                  >
                    Preview
                  </Button> */}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                {searchTerm ? 'No quotations found matching your search.' : 'No quotations available.'}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Box>
    
    {/* Pagination */}
    <TablePagination
      component="div"
      count={filteredData.length}
      page={page}
      onPageChange={handleChangePage}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      rowsPerPageOptions={[5, 10, 25, 50]}
      sx={{ mt: 2 }}
    />
  </Paper>
)}

        <Dialog
          open={openFormDialog}
          onClose={handleCloseForm}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              height: '95vh',
              maxHeight: '95vh'
            }
          }}
        >
          <DialogTitle sx={{ pb: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6">
                {selectedQuotation ? 'Edit Quotation' : 'New Quotation'}
              </Typography>
              <IconButton onClick={handleCloseForm}>

                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          {/* <DialogContent sx={{ overflow: 'auto', px: 3 }}>
          <Grid container spacing={3}>
           
            <Grid item xs={12} lg={6}>
              
              <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
                <Typography variant="h6" component="h2" gutterBottom sx={{ fontSize: '1.1rem' }}>
                  Basic Information
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Quotation Title"
                      value={quotationData.title}
                      onChange={(e) => setQuotationData(prev => ({ ...prev, title: e.target.value }))}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Client Name"
                      value={quotationData.clientName}
                      onChange={(e) => setQuotationData(prev => ({ ...prev, clientName: e.target.value }))}
                      variant="outlined"
                      size="small"
                      placeholder="Enter client name"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Client Address"
                      value={quotationData.clientAddress}
                      onChange={(e) => setQuotationData(prev => ({ ...prev, clientAddress: e.target.value }))}
                      variant="outlined"
                      size="small"
                      multiline
                    
                      placeholder="Enter client address"
                    />
                  </Grid>
                </Grid>
              </Paper>

              <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
                <Typography variant="h6" component="h2" gutterBottom sx={{ fontSize: '1.1rem' }}>
                  Services & Pricing
                </Typography>

                {quotationData.parts.map((part) => (
                  <Card key={part.id} sx={{ mb: 2, boxShadow: 1 }}>
                    <CardHeader
                      sx={{ py: 1 }}
                      title={
                        <Grid container spacing={1} alignItems="center">
                          <Grid item xs={5}>
                            <TextField
                              fullWidth
                              value={part.title}
                              onChange={(e) => updatePart(part.id, 'title', e.target.value)}
                              variant="outlined"
                              size="small"
                              placeholder="Part Title"
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              value={part.description}
                              onChange={(e) => updatePart(part.id, 'description', e.target.value)}
                              variant="outlined"
                              size="small"
                              placeholder="Description"
                            />
                          </Grid>
                          <Grid item xs={1}>
                            <IconButton
                              onClick={() => deletePart(part.id)}
                              color="error"
                              size="small"
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Grid>
                        </Grid>
                      }
                    />
                    <CardContent sx={{ py: 1 }}>
                      {part.items.map((item) => (
                        <Grid container spacing={1} alignItems="center" key={item.id} sx={{ mb: 1 }}>
                          <Grid item xs={7}>
                            <TextField
                              fullWidth
                              value={item.description}
                              onChange={(e) => updateItem(part.id, item.id, 'description', e.target.value)}
                              variant="outlined"
                              size="small"
                              placeholder="Service description"
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <TextField
                              fullWidth
                              type="number"
                              value={item.amount}
                              onChange={(e) => updateItem(part.id, item.id, 'amount', e.target.value)}
                              variant="outlined"
                              size="small"
                              placeholder="0.00"
                              InputProps={{
                                startAdornment: <Typography sx={{ fontSize: '0.9rem' }}>₹</Typography>
                              }}
                            />
                          </Grid>
                          <Grid item xs={1}>
                            <IconButton
                              onClick={() => deleteItem(part.id, item.id)}
                              color="error"
                              size="small"
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Grid>
                        </Grid>
                      ))}

                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1, pt: 1, borderTop: '1px solid #e0e0e0' }}>
                        <Button
                          variant="contained"
                          color="success"
                          startIcon={<AddIcon />}
                          onClick={() => addItem(part.id)}
                          size="small"
                          sx={{ fontSize: '0.75rem' }}
                        >
                          Add Item
                        </Button>
                        <Typography variant="subtitle2" fontWeight="bold">
                          {part.title} Total: ₹{calculatePartTotal(part).toFixed(2)}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                ))}

                <Button
                  fullWidth
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={addPart}
                  size="small"
                  sx={{ mb: 2 }}
                >
                  Add New Part
                </Button>

                <Alert severity="info" sx={{ mb: 1 }}>
                  <Typography variant="h6" fontWeight="bold">
                    Grand Total: ₹{calculateGrandTotal().toFixed(2)}
                  </Typography>
                </Alert>
              </Paper>

              <Paper elevation={2} sx={{ p: 2 }}>
                <Typography variant="h6" component="h2" gutterBottom sx={{ fontSize: '1.1rem' }}>
                  Additional Information
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Note"
                      value={quotationData.note}
                      onChange={(e) => setQuotationData(prev => ({ ...prev, note: e.target.value }))}
                      variant="outlined"
                      size="small"
                      multiline
                      rows={2}
                      InputProps={{
                        startAdornment: <DescriptionIcon sx={{ mr: 1, color: 'action.active', fontSize: 'small' }} />
                      }}
                    />
                  </Grid>
                 <Grid item xs={12}>
  <TextField
    fullWidth
    multiline
    rows={5}
    label="Payment Terms"
    value={quotationData.paymentTermsText}
    onChange={(e) =>
      setQuotationData((prev) => ({
        ...prev,
        paymentTermsText: e.target.value
      }))
    }
    variant="outlined"
    size="small"
    placeholder={`Enter one term per line:\n• 50% advance\n• 50% on delivery`}
    helperText="Enter each payment term on a new line"
    InputProps={{
      sx: {
        '& textarea': {
          resize: 'vertical',
          fontSize: '0.875rem'
        }
      }
    }}
  />
</Grid>


                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Validity"
                      value={quotationData.validity}
                      onChange={(e) => setQuotationData(prev => ({ ...prev, validity: e.target.value }))}
                      variant="outlined"
                      size="small"
                      InputProps={{
                        startAdornment: <CalendarIcon sx={{ mr: 1, color: 'action.active', fontSize: 'small' }} />
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Timeline"
                      value={quotationData.timeline}
                      onChange={(e) => setQuotationData(prev => ({ ...prev, timeline: e.target.value }))}
                      variant="outlined"
                      size="small"
                      InputProps={{
                        startAdornment: <ScheduleIcon sx={{ mr: 1, color: 'action.active', fontSize: 'small' }} />
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Annual Renewal (₹)"
                      type="number"
                      value={quotationData.annualRenewal}
                      onChange={(e) => setQuotationData(prev => ({ ...prev, annualRenewal: parseFloat(e.target.value) || 0 }))}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Paper>

            </Grid>

            
            <Grid item xs={12} lg={6}>
             
              <Paper elevation={2} sx={{ p: 2, height: 'fit-content' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6" component="h2" sx={{ fontSize: '1.1rem' }}>
                    Features
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => setOpenFeatureCategoryDialog(true)}
                    size="small"
                  >
                    Add Category
                  </Button>
                </Box>

                {quotationData.featureCategories.map((category) => (
                  <Card key={category.id} sx={{ mb: 2, bgcolor: category.color || '#f8f9fa', boxShadow: 1 }}>
                    <CardHeader
                      sx={{ py: 1 }}
                      title={
                        <Grid container spacing={1} alignItems="center">
                          <Grid item xs={10}>
                            <TextField
                              fullWidth
                              value={category.name}
                              onChange={(e) => updateFeatureCategoryName(category.id, e.target.value)}
                              variant="outlined"
                              size="small"
                              placeholder="Category Name"
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <IconButton
                              onClick={() => deleteFeatureCategory(category.id)}
                              color="error"
                              size="small"
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Grid>
                        </Grid>
                      }
                    />
                    <CardContent sx={{ py: 1 }}>
                      <TextField
                        fullWidth
                        multiline
                        rows={5}
                        value={category.featuresText || ''}
                        onChange={(e) => updateFeatures(category.id, e.target.value)}
                        variant="outlined"
                        size="small"
                        placeholder={`Enter features, one per line:
• Feature 1
• Feature 2
• Feature 3`}
                        helperText="Type each feature on a new line."
                        InputProps={{
                          sx: {
                            '& textarea': {
                              resize: 'vertical',
                              fontSize: '0.875rem'
                            }
                          }
                        }}
                      />
                    </CardContent>
                  </Card>
                ))}
              </Paper>
            </Grid>
          </Grid>

          
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 3, pb: 2 }}>
            <Button
              variant="contained"
              onClick={handleSave}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} /> : <BusinessIcon />}
              size="large"
            >
              {loading ? 'Saving...' : 'Save Quotation'}
            </Button>

            <Button
              variant="contained"
              color="secondary"
              onClick={handleGeneratePDF}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} /> : <DownloadIcon />}
              size="large"
            >
              {loading ? 'Generating...' : 'Download PDF'}
            </Button>
          </Box>

          
          <Dialog open={openFeatureCategoryDialog} onClose={() => setOpenFeatureCategoryDialog(false)}>
            <DialogTitle>Add New Feature Category</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                margin="dense"
                label="Category Name"
                fullWidth
                variant="outlined"
                size="small"
                value={newCategoryName}
                onChange={(e) => setNewCategoryName(e.target.value)}
                placeholder="e.g., LMS Features, Mobile App Features"
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenFeatureCategoryDialog(false)} size="small">Cancel</Button>
              <Button onClick={addFeatureCategory} variant="contained" size="small">Add Category</Button>
            </DialogActions>
          </Dialog>
        </DialogContent> */}

          <DialogContent sx={{ overflow: 'auto', px: 4, py: 3, bgcolor: '#f8fafc' }}>
            <Grid container spacing={4}>

              {/* Left Column - Form Inputs */}
              <Grid item xs={12} lg={6}>

                {/* Basic Information Section */}
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    mb: 3,
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0',
                    bgcolor: '#ffffff'
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <Box sx={{
                      width: 40,
                      height: 40,
                      borderRadius: '8px',
                      bgcolor: '#3b82f6',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mr: 2
                    }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
                        1
                      </Typography>
                    </Box>
                    <Typography variant="h5" component="h2" sx={{
                      fontWeight: 600,
                      color: '#1e293b',
                      fontSize: '1.25rem'
                    }}>
                      Basic Information
                    </Typography>
                  </Box>

                  <Grid container spacing={3} >
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Quotation Title"
                        value={quotationData.title}
                        onChange={(e) => setQuotationData(prev => ({ ...prev, title: e.target.value }))}
                        variant="outlined"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            bgcolor: '#f8fafc'
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Client Name"
                        value={quotationData.clientName}
                        onChange={(e) => setQuotationData(prev => ({ ...prev, clientName: e.target.value }))}
                        variant="outlined"
                        placeholder="Enter client name"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            bgcolor: '#f8fafc'
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Client Address"
                        value={quotationData.clientAddress}
                        onChange={(e) => setQuotationData(prev => ({ ...prev, clientAddress: e.target.value }))}
                        variant="outlined"
                        multiline

                        placeholder="Enter client address"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            bgcolor: '#f8fafc'
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                </Paper>

                {/* Services & Pricing Section */}
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    mb: 3,
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0',
                    bgcolor: '#ffffff'
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, justifyContent: "space-between" }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography variant="h6" sx={{
                        color: 'white', fontWeight: 'bold', width: 40,
                        height: 40,
                        borderRadius: '8px',
                        bgcolor: '#10b981',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mr: 2
                      }}>
                        2
                      </Typography>

                      <Typography variant="h5" component="h2" sx={{
                        fontWeight: 600,
                        color: '#1e293b',
                        fontSize: '1.25rem'
                      }}>
                        Services & Pricing
                      </Typography>
                    </Box>


                    <Button

                      variant="contained"
                      startIcon={<AddIcon />}
                      onClick={addPart}
                      sx={{
                        mb: 3,
                        py: 1.5,
                        borderRadius: '8px',
                        bgcolor: '#3b82f6',
                        '&:hover': { bgcolor: '#2563eb' },
                        textTransform: 'none',
                        fontWeight: 500,
                        width: "200px"
                      }}
                    >
                      Add New Part
                    </Button>
                  </Box>

                  {quotationData.parts.map((part, index) => (
                    <Card
                      key={part.id}
                      sx={{
                        mb: 3,
                        borderRadius: '12px',
                        border: '1px solid #e2e8f0',
                        boxShadow: 'none',
                        bgcolor: '#fefefe'
                      }}
                    >
                      <CardHeader
                        sx={{
                          py: 2,
                          px: 3,
                          bgcolor: '#f1f5f9',
                          borderBottom: '1px solid #e2e8f0'
                        }}
                        title={
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box sx={{ display: 'flex', alignItems: "start", gap: 2, flex: 1 }}>
                              <TextField
                                value={part.title}
                                onChange={(e) => updatePart(part.id, 'title', e.target.value)}
                                variant="outlined"
                                size="small"
                                placeholder="Part Title"
                                sx={{
                                  flex: 1,
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '6px',
                                    bgcolor: 'white',
                                    width: "200px"
                                  }
                                }}
                              />
                              <TextField
                                value={part.description}
                                onChange={(e) => updatePart(part.id, 'description', e.target.value)}
                                variant="outlined"
                                size="small"
                                placeholder="Description"
                                sx={{
                                  flex: 1,
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '6px',
                                    bgcolor: 'white',
                                    width: "200px"
                                  }
                                }}
                              />
                            </Box>
                            <IconButton
                              onClick={() => deletePart(part.id)}
                              sx={{
                                color: '#ef4444',
                                bgcolor: '#fef2f2',
                                '&:hover': { bgcolor: '#fee2e2' },
                                ml: 20,
                                width: "50px"
                              }}
                              size="small"
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        }
                      />
                      <CardContent sx={{ p: 3 }}>
                        {part.items.map((item, itemIndex) => (
                          <Box
                            key={item.id}
                            sx={{
                              p: 2,
                              borderRadius: '8px',
                              border: '1px solid #f1f5f9',
                              bgcolor: '#fafbfc'
                            }}
                          >
                            <Box sx={{ display: 'flex', gap: 2, mb: 2, justifyContent: "space-between" }}>
                              <TextField
                                value={item.description}
                                onChange={(e) => updateItem(part.id, item.id, 'description', e.target.value)}
                                variant="outlined"
                                size="small"
                                placeholder="Service description"
                                sx={{

                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '6px',
                                    bgcolor: 'white',

                                  }
                                }}
                              />
                              <TextField
                                type="number"
                                value={item.amount}
                                onChange={(e) => updateItem(part.id, item.id, 'amount', e.target.value)}
                                variant="outlined"
                                size="small"
                                placeholder="0.00"
                                sx={{

                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '6px',
                                    bgcolor: 'white'
                                  }
                                }}
                                InputProps={{
                                  startAdornment: <Typography sx={{
                                    fontSize: '0.9rem',
                                    color: '#64748b',
                                    fontWeight: 500
                                  }}>₹</Typography>
                                }}
                              />
                              <IconButton
                                onClick={() => deleteItem(part.id, item.id)}
                                sx={{
                                  color: '#ef4444',
                                  bgcolor: '#fef2f2',
                                  width: "50px"
                                }}
                                size="small"
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </Box>
                        ))}

                        <Box sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          mt: 3,
                          pt: 2,
                          borderTop: '2px solid #f1f5f9'
                        }}>
                          <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            onClick={() => addItem(part.id)}
                            size="small"
                            sx={{
                              borderRadius: '8px',
                              bgcolor: '#10b981',
                              '&:hover': { bgcolor: '#059669' },
                              textTransform: 'none',
                              fontWeight: 500,
                              width: "200px"
                            }}
                          >
                            Add Item
                          </Button>
                          <Box sx={{
                            px: 3,
                            py: 1,
                            borderRadius: '8px',
                            bgcolor: '#f0f9ff',
                            border: '1px solid #e0f2fe'
                          }}>
                            <Typography variant="subtitle2" sx={{
                              fontWeight: 600,
                              color: '#0369a1'
                            }}>
                              {part.title} Total: ₹{calculatePartTotal(part).toFixed(2)}
                            </Typography>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  ))}

                 <Paper
    sx={{
      p: 3,
      mb: 2,
      borderRadius: '12px',
      border: '1px solid #e2e8f0',
      boxShadow: 'none',
      bgcolor: '#fefefe'
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#475569', flex: 1 }}>
        Discount (Optional)
      </Typography>
      <TextField
        type="number"
        value={quotationData.discount || ''}
        onChange={(e) => updateDiscount(e.target.value)}
        variant="outlined"
        size="small"
        placeholder="0.00"
        sx={{
          width: '150px',
          '& .MuiOutlinedInput-root': {
            borderRadius: '6px',
            bgcolor: 'white'
          }
        }}
        InputProps={{
          startAdornment: <Typography sx={{
            fontSize: '0.9rem',
            color: '#64748b',
            fontWeight: 500
          }}>₹</Typography>
        }}
      />
    </Box>
  </Paper>

                  <Alert
                    severity="success"
                    sx={{
                      borderRadius: '12px',
                      border: '1px solid #d1fae5',
                      bgcolor: '#f0fdf4'
                    }}
                  >
                    <Typography variant="h6" sx={{
                      fontWeight: 700,
                      color: '#166534'
                    }}>
                      Grand Total: ₹{calculateGrandTotal().toFixed(2)}
                    </Typography>
                  </Alert>
                </Paper>

                {/* Additional Information Section */}
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0',
                    bgcolor: '#ffffff'
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <Box sx={{
                      width: 40,
                      height: 40,
                      borderRadius: '8px',
                      bgcolor: '#f59e0b',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mr: 2
                    }}>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
                        3
                      </Typography>
                    </Box>
                    <Typography variant="h5" component="h2" sx={{
                      fontWeight: 600,
                      color: '#1e293b',
                      fontSize: '1.25rem'
                    }}>
                      Additional Information
                    </Typography>
                  </Box>

                  <Grid container spacing={3} >
                    <Grid item lg={12}>
                      <TextField
                        fullWidth
                        label="Note"
                        value={quotationData.note}
                        onChange={(e) => setQuotationData(prev => ({ ...prev, note: e.target.value }))}
                        variant="outlined"
                        multiline
                        rows={3}
                        InputProps={{
                          startAdornment: <DescriptionIcon sx={{
                            mr: 1,
                            color: '#64748b',
                            fontSize: 'small'
                          }} />
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            bgcolor: '#f8fafc'
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label="Payment Terms"
                        value={quotationData.paymentTermsText}
                        onChange={(e) =>
                          setQuotationData((prev) => ({
                            ...prev,
                            paymentTermsText: e.target.value
                          }))
                        }
                        variant="outlined"
                        placeholder={`Enter one term per line:\n• 50% advance\n• 50% on delivery`}
                        helperText="Enter each payment term on a new line"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            bgcolor: '#f8fafc'
                          },
                          '& textarea': {
                            resize: 'vertical',
                            fontSize: '0.875rem'
                          },
                          width: "510px"
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Validity"
                        value={quotationData.validity}
                        onChange={(e) => setQuotationData(prev => ({ ...prev, validity: e.target.value }))}
                        variant="outlined"
                        InputProps={{
                          startAdornment: <CalendarIcon sx={{
                            mr: 1,
                            color: '#64748b',
                            fontSize: 'small'
                          }} />
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            bgcolor: '#f8fafc'
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Timeline"
                        value={quotationData.timeline}
                        onChange={(e) => setQuotationData(prev => ({ ...prev, timeline: e.target.value }))}
                        variant="outlined"
                        InputProps={{
                          startAdornment: <ScheduleIcon sx={{
                            mr: 1,
                            color: '#64748b',
                            fontSize: 'small'
                          }} />
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            bgcolor: '#f8fafc'
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Annual Renewal (₹)"
                        type="number"
                        value={quotationData.annualRenewal}
                        onChange={(e) => setQuotationData(prev => ({ ...prev, annualRenewal: parseFloat(e.target.value) || 0 }))}
                        variant="outlined"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            bgcolor: '#f8fafc'
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>

              {/* Right Column - Features */}
              <Grid item xs={12} lg={6}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    height: 'fit-content',
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0',
                    bgcolor: '#ffffff'
                  }}
                >
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: "5",
                    mb: 3,
                  }} xs={12}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '8px',
                        bgcolor: '#8b5cf6',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mr: 2
                      }}>
                        <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
                          4
                        </Typography>
                      </Box>
                      <Typography variant="h5" component="h2" sx={{
                        fontWeight: 600,
                        color: '#1e293b',
                        fontSize: '1.25rem'
                      }}>
                        Features
                      </Typography>
                    </Box>
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      onClick={() => setOpenFeatureCategoryDialog(true)}
                      sx={{
                        borderRadius: '8px',
                        bgcolor: '#8b5cf6',
                        '&:hover': { bgcolor: '#7c3aed' },
                        textTransform: 'none',
                        fontWeight: 500
                      }}
                    >
                      Add Category
                    </Button>
                  </Box>

                  {quotationData.featureCategories.map((category, index) => (
                    <Card
                      key={category.id}
                      sx={{
                        mb: 3,
                        borderRadius: '12px',
                        border: '1px solid #e2e8f0',
                        boxShadow: 'none',
                        bgcolor: category.color || '#fefefe'
                      }}
                    >
                      <CardHeader
                        sx={{
                          py: 2,
                          px: 3,
                          bgcolor: 'rgba(139, 92, 246, 0.1)',
                          borderBottom: '1px solid #e2e8f0'
                        }}
                        title={
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={10}>
                              <TextField
                                fullWidth
                                value={category.name}
                                onChange={(e) => updateFeatureCategoryName(category.id, e.target.value)}
                                variant="outlined"
                                size="small"
                                placeholder="Category Name"
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '6px',
                                    bgcolor: 'white'
                                  }
                                }}
                              />
                            </Grid>
                            <Grid item xs={2}>
                              <IconButton
                                onClick={() => deleteFeatureCategory(category.id)}
                                sx={{
                                  color: '#ef4444',
                                  bgcolor: '#fef2f2',
                                  '&:hover': { bgcolor: '#fee2e2' }
                                }}
                                size="small"
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Grid>
                          </Grid>
                        }
                      />
                      <CardContent sx={{ p: 3 }}>
                        <TextField
                          fullWidth
                          multiline
                          rows={5}
                          value={category.featuresText || ''}
                          onChange={(e) => updateFeatures(category.id, e.target.value)}
                          variant="outlined"
                          placeholder={`Enter features, one per line:
• Feature 1
• Feature 2
• Feature 3`}
                          helperText="Type each feature on a new line."
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px',
                              bgcolor: '#f8fafc'
                            },
                            '& textarea': {
                              resize: 'vertical',
                              fontSize: '0.875rem'
                            }
                          }}
                        />
                      </CardContent>
                    </Card>
                  ))}
                </Paper>
              </Grid>
            </Grid>

            {/* Action Buttons */}
            <Box sx={{
              display: 'flex',
              gap: 3,
              justifyContent: 'center',
              mt: 4,
              pb: 3
            }}>
            <Button
  variant="contained"
  onClick={handleSave}
  disabled={loading}
  startIcon={loading ? <CircularProgress size={20} /> : <BusinessIcon />}
  size="large"
  sx={{
    px: 4,
    py: 1.5,
    borderRadius: '12px',
    bgcolor: '#3b82f6',
    '&:hover': { bgcolor: '#2563eb' },
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '1rem'
  }}
>
  {loading ? 'Saving & Generating Preview...' : 'Save & Preview Quotation'}
</Button>


              <Button
                variant="contained"
                onClick={handleGeneratePDF}
                disabled={loading}
                startIcon={loading ? <CircularProgress size={20} /> : <DownloadIcon />}
                size="large"
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: '12px',
                  bgcolor: '#10b981',
                  '&:hover': { bgcolor: '#059669' },
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '1rem'
                }}
              >
                {loading ? 'Generating...' : 'Download PDF'}
              </Button>
            </Box>

            {/* Feature Category Dialog */}
            <Dialog
              open={openFeatureCategoryDialog}
              onClose={() => setOpenFeatureCategoryDialog(false)}
              PaperProps={{
                sx: {
                  borderRadius: '12px',
                  minWidth: '400px'
                }
              }}
            >
              <DialogTitle sx={{
                fontWeight: 600,
                color: '#1e293b',
                pb: 2
              }}>
                Add New Feature Category
              </DialogTitle>
              <DialogContent>
                <TextField
                  autoFocus
                  margin="dense"
                  label="Category Name"
                  fullWidth
                  variant="outlined"
                  value={newCategoryName}
                  onChange={(e) => setNewCategoryName(e.target.value)}
                  placeholder="e.g., LMS Features, Mobile App Features"
                  sx={{
                    mt: 2,
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px'
                    }
                  }}
                />
              </DialogContent>
              <DialogActions sx={{ p: 3, pt: 2 }}>
                <Button
                  onClick={() => setOpenFeatureCategoryDialog(false)}
                  sx={{
                    color: '#64748b',
                    textTransform: 'none'
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={addFeatureCategory}
                  variant="contained"
                  sx={{
                    borderRadius: '8px',
                    bgcolor: '#8b5cf6',
                    '&:hover': { bgcolor: '#7c3aed' },
                    textTransform: 'none',
                    fontWeight: 500
                  }}
                >
                  Add Category
                </Button>
              </DialogActions>
            </Dialog>
          </DialogContent>
        </Dialog>
      </Container>



    </>
  );
};

export default DynamicQuotationForm;